webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),c=[],u=!1,a=-1,s=void 0,v=void 0,f=function(t){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},m=function(e){var t=e||window.event;return!!f(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))},o=function(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})};exports.disableBodyScroll=function(i,e){if(d){if(!i)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(i&&!c.some(function(e){return e.targetElement===i})){var t={targetElement:i,options:e||{}};c=[].concat(r(c),[t]),i.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},i.ontouchmove=function(e){var t,o,n,r;1===e.targetTouches.length&&(o=i,r=(t=e).targetTouches[0].clientY-a,!f(t.target)&&(o&&0===o.scrollTop&&0<r?m(t):(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&r<0?m(t):t.stopPropagation()))},u||(document.addEventListener("touchmove",m,l?{passive:!1}:void 0),u=!0)}}else{n=e,setTimeout(function(){if(void 0===v){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:i,options:e||{}};c=[].concat(r(c),[o])}var n},exports.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1),c=[],a=-1):(o(),c=[])},exports.enableBodyScroll=function(t){if(d){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,c=c.filter(function(e){return e.targetElement!==t}),u&&0===c.length&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1)}else(c=c.filter(function(e){return e.targetElement!==t})).length||o()}});


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setInitial;
/* harmony export (immutable) */ __webpack_exports__["c"] = setLoading;
/* harmony export (immutable) */ __webpack_exports__["a"] = setFinished;
/* unused harmony export LoadingButton */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Set button to a loading or finished state
 *
 * @since 1.0.0
 */

function setInitial(el) {
  el.classList.remove('c-button--loading');
  el.classList.remove('c-button--finished');
}

function setLoading(el) {
  el.classList.add('c-button--loading');
}

function setFinished(el) {
  el.classList.remove('c-button--loading');
  el.classList.add('c-button--finished');
}

function LoadingButton() {
  var buttons = document.querySelectorAll('.js-loading-button');
  if (buttons.length < 1) return;[].concat(_toConsumableArray(buttons)).forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      setLoading(button);
      setTimeout(function () {
        setFinished(button);
        setTimeout(function () {
          setInitial(button);
        }, 2000);
      }, 2000);
    });
  });
}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_objectFitPolyfill__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_objectFitPolyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_objectFitPolyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smoothscroll__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smoothscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_smoothscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_fit_images__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ObserveFontFace__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_FormValidation__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_SendForm__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_DependsOn__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_UploadButton__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_LazyLoadImage__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_LazyLoadPicture__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_LazyLoadVideo__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_Map__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_ReadMore__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_StickyHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_Click__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_MobileNav__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_SendLoginForm__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_SwipeSlider__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_SwipeOneSlider__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_Lightbox__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_ChildClick__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_Video__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_VideoPopup__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_ProductSlider__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_Wishlist__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_Parallax__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_ThumbnailSlider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_Tabs__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_Blur__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_CarVideo__ = __webpack_require__(173);
/**
 * Main.js
 *
 * @since 1.0.0
 */




// import Raven from 'raven-js'


























(function IIFE() {
  // if (process.env.NODE_ENV === 'production') {
  // Raven
  // .config('')
  // .install()
  // }
  Object(__WEBPACK_IMPORTED_MODULE_3__modules_ObserveFontFace__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_2_object_fit_images___default()();
  Object(__WEBPACK_IMPORTED_MODULE_4__modules_FormValidation__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_5__modules_SendForm__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_6__modules_DependsOn__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_7__modules_UploadButton__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_8__modules_LazyLoadImage__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_9__modules_LazyLoadPicture__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_10__modules_LazyLoadVideo__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_11__modules_Map__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_12__modules_ReadMore__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_13__modules_StickyHeader__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_14__modules_Click__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_15__modules_MobileNav__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_16__modules_SendLoginForm__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_17__modules_SwipeSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_18__modules_SwipeOneSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_19__modules_Lightbox__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_20__modules_ChildClick__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_21__modules_Video__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_22__modules_VideoPopup__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_23__modules_ProductSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_24__modules_Wishlist__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_25__modules_Parallax__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_26__modules_ThumbnailSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_27__modules_Tabs__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_28__modules_Blur__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_29__modules_CarVideo__["a" /* default */])();
})();

/***/ }),
/* 139 */
/***/ (function(module, exports) {

!function(){"use strict";if("undefined"!=typeof window){var t=window.navigator.userAgent.match(/Edge\/(\d{2})\./),e=!!t&&parseInt(t[1],10)>=16;if("objectFit"in document.documentElement.style!=!1&&!e)return void(window.objectFitPolyfill=function(){return!1});var i=function(t){var e=window.getComputedStyle(t,null),i=e.getPropertyValue("position"),n=e.getPropertyValue("overflow"),o=e.getPropertyValue("display");i&&"static"!==i||(t.style.position="relative"),"hidden"!==n&&(t.style.overflow="hidden"),o&&"inline"!==o||(t.style.display="block"),0===t.clientHeight&&(t.style.height="100%"),-1===t.className.indexOf("object-fit-polyfill")&&(t.className=t.className+" object-fit-polyfill")},n=function(t){var e=window.getComputedStyle(t,null),i={"max-width":"none","max-height":"none","min-width":"0px","min-height":"0px",top:"auto",right:"auto",bottom:"auto",left:"auto","margin-top":"0px","margin-right":"0px","margin-bottom":"0px","margin-left":"0px"};for(var n in i){e.getPropertyValue(n)!==i[n]&&(t.style[n]=i[n])}},o=function(t,e,i){var n,o,l,a,d;if(i=i.split(" "),i.length<2&&(i[1]=i[0]),"x"===t)n=i[0],o=i[1],l="left",a="right",d=e.clientWidth;else{if("y"!==t)return;n=i[1],o=i[0],l="top",a="bottom",d=e.clientHeight}return n===l||o===l?void(e.style[l]="0"):n===a||o===a?void(e.style[a]="0"):"center"===n||"50%"===n?(e.style[l]="50%",void(e.style["margin-"+l]=d/-2+"px")):n.indexOf("%")>=0?(n=parseInt(n),void(n<50?(e.style[l]=n+"%",e.style["margin-"+l]=d*(n/-100)+"px"):(n=100-n,e.style[a]=n+"%",e.style["margin-"+a]=d*(n/-100)+"px"))):void(e.style[l]=n)},l=function(t){var e=t.dataset?t.dataset.objectFit:t.getAttribute("data-object-fit"),l=t.dataset?t.dataset.objectPosition:t.getAttribute("data-object-position");e=e||"cover",l=l||"50% 50%";var a=t.parentNode;i(a),n(t),t.style.position="absolute",t.style.height="100%",t.style.width="auto","scale-down"===e&&(t.style.height="auto",t.clientWidth<a.clientWidth&&t.clientHeight<a.clientHeight?(o("x",t,l),o("y",t,l)):(e="contain",t.style.height="100%")),"none"===e?(t.style.width="auto",t.style.height="auto",o("x",t,l),o("y",t,l)):"cover"===e&&t.clientWidth>a.clientWidth||"contain"===e&&t.clientWidth<a.clientWidth?(t.style.top="0",t.style.marginTop="0",o("x",t,l)):"scale-down"!==e&&(t.style.width="100%",t.style.height="auto",t.style.left="0",t.style.marginLeft="0",o("y",t,l))},a=function(t){if(void 0===t)t=document.querySelectorAll("[data-object-fit]");else if(t&&t.nodeName)t=[t];else{if("object"!=typeof t||!t.length||!t[0].nodeName)return!1;t=t}for(var i=0;i<t.length;i++)if(t[i].nodeName){var n=t[i].nodeName.toLowerCase();"img"!==n||e?"video"===n&&(t[i].readyState>0?l(t[i]):t[i].addEventListener("loadedmetadata",function(){l(this)})):t[i].complete?l(t[i]):t[i].addEventListener("load",function(){l(this)})}return!0};document.addEventListener("DOMContentLoaded",function(){a()}),window.addEventListener("resize",function(){a()}),window.objectFitPolyfill=a}}();

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, smoothScroll) {
  'use strict';

  // Support RequireJS and CommonJS/NodeJS module formats.
  // Attach smoothScroll to the `window` when executed as a <script>.

  // RequireJS
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (smoothScroll),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // CommonJS
  } else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = smoothScroll();

  } else {
    root.smoothScroll = smoothScroll();
  }

})(this, function(){
'use strict';

// Do not initialize smoothScroll when running server side, handle it in client:
if (typeof window !== 'object') return;

// We do not want this script to be applied in browsers that do not support those
// That means no smoothscroll on IE9 and below.
if(document.querySelectorAll === void 0 || window.pageYOffset === void 0 || history.pushState === void 0) { return; }

// Get the top position of an element in the document
var getTop = function(element, start) {
    // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
    if(element.nodeName === 'HTML') return -start
    return element.getBoundingClientRect().top + start
}
// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
var easeInOutCubic = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }

// calculate the scroll position we should be in
// given the start and end point of the scroll
// the time elapsed from the beginning of the scroll
// and the total duration of the scroll (default 500ms)
var position = function(start, end, elapsed, duration) {
    if (elapsed > duration) return end;
    return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
    // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}

// we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if the callback exist, it is called when the scrolling is finished
// if context is set then scroll that element, else scroll window
var smoothScroll = function(el, duration, callback, context){
    duration = duration || 500;
    context = context || window;
    var start = context.scrollTop || window.pageYOffset;

    if (typeof el === 'number') {
      var end = parseInt(el);
    } else {
      var end = getTop(el, start);
    }

    var clock = Date.now();
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
        function(fn){window.setTimeout(fn, 15);};

    var step = function(){
        var elapsed = Date.now() - clock;
        if (context !== window) {
          context.scrollTop = position(start, end, elapsed, duration);
        }
        else {
          window.scroll(0, position(start, end, elapsed, duration));
        }

        if (elapsed > duration) {
            if (typeof callback === 'function') {
                callback(el);
            }
        } else {
            requestAnimationFrame(step);
        }
    }
    step();
}

var linkHandler = function(ev) {
    if (!ev.defaultPrevented) {
        ev.preventDefault();

        if (location.hash !== this.hash) window.history.pushState(null, null, this.hash)
        // using the history api to solve issue #1 - back doesn't work
        // most browser don't update :target when the history api is used:
        // THIS IS A BUG FROM THE BROWSERS.
        // change the scrolling duration in this call
        var node = document.getElementById(this.hash.substring(1))
        if (!node) return; // Do not scroll to non-existing node

        smoothScroll(node, 500, function (el) {
            location.replace('#' + el.id)
            // this will cause the :target to be activated.
        });
    }
}

// We look for all the internal links in the documents and attach the smoothscroll function
document.addEventListener("DOMContentLoaded", function () {
    var internal = document.querySelectorAll('a[href^="#"]:not([href="#"])'), a;
    for(var i=internal.length; a=internal[--i];){
        a.addEventListener("click", linkHandler, false);
    }
});

// return smoothscroll API
return smoothScroll;

});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.4 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__);
/**
 * Observe Fontface
 *
 * @since 1.0.0
 */



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var font = new __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default.a('Nunito Sans'); // Add font here
  font.load().then(function () {
    if (!document.documentElement.classList.contains('fonts-loaded')) {
      document.documentElement.classList.add('fonts-loaded');
    }
  });
});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);z(a)};function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10)}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},b)}e()}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"))},n)});Promise.race([N,M]).then(function(){clearTimeout(r);a(c)},
b)}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c))}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50)}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v()});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v()});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v()});u(q,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=B:(window.FontFaceObserver=B,window.FontFaceObserver.prototype.load=B.prototype.load);}());


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Form validation
 *
 * @since 1.0.0
 */


var FormValidation = function FormValidation() {
  var forms = document.querySelectorAll('.js-form, .js-login-form');
  if (forms.length < 1) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {
    window.hyperform(form);
    var inputs = form.querySelectorAll('input,textarea,select');[].concat(_toConsumableArray(inputs)).forEach(function (input) {
      if (input.required) {
        // All required inputs
        input.addEventListener('invalid', function (e) {
          return e.preventDefault();
        });
      }
    });
  }); // End forEach
};

/* harmony default export */ __webpack_exports__["a"] = (FormValidation);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)(__webpack_require__(147))

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "/*! hyperform.js.org */\nvar hyperform = (function () {\n                       'use strict';\n\n                       /* the following code is borrowed from the WebComponents project, licensed\n                        * under the BSD license. Source:\n                        * <https://github.com/webcomponents/webcomponentsjs/blob/5283db1459fa2323e5bfc8b9b5cc1753ed85e3d0/src/WebComponents/dom.js#L53-L78>\n                        */\n                       // defaultPrevented is broken in IE.\n                       // https://connect.microsoft.com/IE/feedback/details/790389/event-defaultprevented-returns-false-after-preventdefault-was-called\n\n                       var workingDefaultPrevented = function () {\n                         var e = document.createEvent('Event');\n                         e.initEvent('foo', true, true);\n                         e.preventDefault();\n                         return e.defaultPrevented;\n                       }();\n\n                       if (!workingDefaultPrevented) {\n                         (function () {\n                           var origPreventDefault = window.Event.prototype.preventDefault;\n                           window.Event.prototype.preventDefault = function () {\n                             if (!this.cancelable) {\n                               return;\n                             }\n\n                             origPreventDefault.call(this);\n\n                             Object.defineProperty(this, 'defaultPrevented', {\n                               get: function get() {\n                                 return true;\n                               },\n                               configurable: true\n                             });\n                           };\n                         })();\n                       }\n                       /* end of borrowed code */\n\n                       function create_event(name) {\n                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n\n                         var _ref$bubbles = _ref.bubbles;\n                         var bubbles = _ref$bubbles === undefined ? true : _ref$bubbles;\n                         var _ref$cancelable = _ref.cancelable;\n                         var cancelable = _ref$cancelable === undefined ? false : _ref$cancelable;\n\n                         var event = document.createEvent('Event');\n                         event.initEvent(name, bubbles, cancelable);\n                         return event;\n                       }\n\n                       function trigger_event (element, event) {\n                         var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n\n                         var _ref2$bubbles = _ref2.bubbles;\n                         var bubbles = _ref2$bubbles === undefined ? true : _ref2$bubbles;\n                         var _ref2$cancelable = _ref2.cancelable;\n                         var cancelable = _ref2$cancelable === undefined ? false : _ref2$cancelable;\n                         var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};\n\n                         if (!(event instanceof window.Event)) {\n                           event = create_event(event, { bubbles: bubbles, cancelable: cancelable });\n                         }\n\n                         for (var key in payload) {\n                           if (payload.hasOwnProperty(key)) {\n                             event[key] = payload[key];\n                           }\n                         }\n\n                         element.dispatchEvent(event);\n\n                         return event;\n                       }\n\n                       /* shim layer for the Element.matches method */\n\n                       var ep = window.Element.prototype;\n                       var native_matches = ep.matches || ep.matchesSelector || ep.msMatchesSelector || ep.webkitMatchesSelector;\n\n                       function matches (element, selector) {\n                                              return native_matches.call(element, selector);\n                       }\n\n                       /**\n                        * mark an object with a '__hyperform=true' property\n                        *\n                        * We use this to distinguish our properties from the native ones. Usage:\n                        * js> mark(obj);\n                        * js> assert(obj.__hyperform === true)\n                        */\n\n                       function mark (obj) {\n                         if (['object', 'function'].indexOf(typeof obj) > -1) {\n                           delete obj.__hyperform;\n                           Object.defineProperty(obj, '__hyperform', {\n                             configurable: true,\n                             enumerable: false,\n                             value: true\n                           });\n                         }\n\n                         return obj;\n                       }\n\n                       /**\n                        * the internal storage for messages\n                        */\n                       var store = new WeakMap();\n\n                       /* jshint -W053 */ /* allow new String() */\n                       /**\n                        * handle validation messages\n                        *\n                        * Falls back to browser-native errors, if any are available. The messages\n                        * are String objects so that we can mark() them.\n                        */\n                       var message_store = {\n                         set: function set(element, message) {\n                           var is_custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;\n\n                           if (element instanceof window.HTMLFieldSetElement) {\n                             var wrapped_form = get_wrapper(element);\n                             if (wrapped_form && !wrapped_form.settings.extendFieldset) {\n                               /* make this a no-op for <fieldset> in strict mode */\n                               return message_store;\n                             }\n                           }\n\n                           if (typeof message === 'string') {\n                             message = new String(message);\n                           }\n                           if (is_custom) {\n                             message.is_custom = true;\n                           }\n                           mark(message);\n                           store.set(element, message);\n\n                           /* allow the :invalid selector to match */\n                           if ('_original_setCustomValidity' in element) {\n                             element._original_setCustomValidity(message.toString());\n                           }\n\n                           return message_store;\n                         },\n                         get: function get(element) {\n                           var message = store.get(element);\n                           if (message === undefined && '_original_validationMessage' in element) {\n                             /* get the browser's validation message, if we have none. Maybe it\n                              * knows more than we. */\n                             message = new String(element._original_validationMessage);\n                           }\n                           return message ? message : new String('');\n                         },\n                         delete: function _delete(element) {\n                           var is_custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                           if ('_original_setCustomValidity' in element) {\n                             element._original_setCustomValidity('');\n                           }\n                           var message = store.get(element);\n                           if (message && is_custom && !message.is_custom) {\n                             /* do not delete \"native\" messages, if asked */\n                             return false;\n                           }\n                           return store.delete(element);\n                         }\n                       };\n\n                       /**\n                        * counter that will be incremented with every call\n                        *\n                        * Will enforce uniqueness, as long as no more than 1 hyperform scripts\n                        * are loaded. (In that case we still have the \"random\" part below.)\n                        */\n\n                       var uid = 0;\n\n                       /**\n                        * generate a random ID\n                        *\n                        * @see https://gist.github.com/gordonbrander/2230317\n                        */\n                       function generate_id () {\n                         var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hf_';\n\n                         return prefix + uid++ + Math.random().toString(36).substr(2);\n                       }\n\n                       /**\n                        * get all radio buttons (including `element`) that belong to element's\n                        * radio group\n                        */\n\n                       function get_radiogroup(element) {\n                         if (element.form) {\n                           return Array.prototype.filter.call(element.form.elements, function (radio) {\n                             return radio.type === 'radio' && radio.name === element.name;\n                           });\n                         }\n                         return [element];\n                       }\n\n                       var warningsCache = new WeakMap();\n\n                       var DefaultRenderer = {\n\n                         /**\n                          * called when a warning should become visible\n                          */\n                         attachWarning: function attachWarning(warning, element) {\n                           /* should also work, if element is last,\n                            * http://stackoverflow.com/a/4793630/113195 */\n                           element.parentNode.insertBefore(warning, element.nextSibling);\n                         },\n\n                         /**\n                          * called when a warning should vanish\n                          */\n                         detachWarning: function detachWarning(warning, element) {\n                           /* be conservative here, since an overwritten attachWarning() might not\n                            * actually have attached the warning. */\n                           if (warning.parentNode) {\n                             warning.parentNode.removeChild(warning);\n                           }\n                         },\n\n                         /**\n                          * called when feedback to an element's state should be handled\n                          *\n                          * i.e., showing and hiding warnings\n                          */\n                         showWarning: function showWarning(element) {\n                           var whole_form_validated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                           /* don't render error messages on subsequent radio buttons of the\n                            * same group. This assumes, that element.validity.valueMissing is the only\n                            * possible validation failure for radio buttons. */\n                           if (whole_form_validated && element.type === 'radio' && get_radiogroup(element)[0] !== element) {\n                             return;\n                           }\n\n                           var msg = message_store.get(element).toString();\n                           var warning = warningsCache.get(element);\n\n                           if (msg) {\n                             if (!warning) {\n                               var wrapper = get_wrapper(element);\n                               warning = document.createElement('div');\n                               warning.className = wrapper && wrapper.settings.classes.warning || 'hf-warning';\n                               warning.id = generate_id();\n                               warning.setAttribute('aria-live', 'polite');\n                               warningsCache.set(element, warning);\n                             }\n\n                             element.setAttribute('aria-errormessage', warning.id);\n                             if (!element.hasAttribute('aria-describedby')) {\n                               element.setAttribute('aria-describedby', warning.id);\n                             }\n                             Renderer.setMessage(warning, msg, element);\n                             Renderer.attachWarning(warning, element);\n                           } else if (warning && warning.parentNode) {\n                             if (element.getAttribute('aria-describedby') === warning.id) {\n                               element.removeAttribute('aria-describedby');\n                             }\n                             element.removeAttribute('aria-errormessage');\n                             Renderer.detachWarning(warning, element);\n                           }\n                         },\n\n                         /**\n                          * set the warning's content\n                          *\n                          * Overwrite this method, if you want, e.g., to allow HTML in warnings\n                          * or preprocess the content.\n                          */\n                         setMessage: function setMessage(warning, message, element) {\n                           warning.textContent = message;\n                         }\n\n                       };\n\n                       var Renderer = {\n\n                         attachWarning: DefaultRenderer.attachWarning,\n                         detachWarning: DefaultRenderer.detachWarning,\n                         showWarning: DefaultRenderer.showWarning,\n                         setMessage: DefaultRenderer.setMessage,\n\n                         set: function set(renderer, action) {\n                           if (renderer.indexOf('_') > -1) {\n                             /* global console */\n                             // TODO delete before next non-patch version\n                             console.log('Renderer.set: please use camelCase names. ' + renderer + ' will be removed in the next non-patch release.');\n                             renderer = renderer.replace(/_([a-z])/g, function (g) {\n                               return g[1].toUpperCase();\n                             });\n                           }\n                           if (!action) {\n                             action = DefaultRenderer[renderer];\n                           }\n                           Renderer[renderer] = action;\n                         },\n\n                         getWarning: function getWarning(element) {\n                           return warningsCache.get(element);\n                         }\n\n                       };\n\n                       var registry = Object.create(null);\n\n                       /**\n                        * run all actions registered for a hook\n                        *\n                        * Every action gets called with a state object as `this` argument and with the\n                        * hook's call arguments as call arguments.\n                        *\n                        * @return mixed the returned value of the action calls or undefined\n                        */\n                       function call_hook(hook) {\n                         var result;\n                         var call_args = Array.prototype.slice.call(arguments, 1);\n\n                         if (hook in registry) {\n                           result = registry[hook].reduce(function (args) {\n\n                             return function (previousResult, currentAction) {\n                               var interimResult = currentAction.apply({\n                                 state: previousResult,\n                                 hook: hook\n                               }, args);\n                               return interimResult !== undefined ? interimResult : previousResult;\n                             };\n                           }(call_args), result);\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * Filter a value through hooked functions\n                        *\n                        * Allows for additional parameters:\n                        * js> do_filter('foo', null, current_element)\n                        */\n                       function do_filter(hook, initial_value) {\n                         var result = initial_value;\n                         var call_args = Array.prototype.slice.call(arguments, 1);\n\n                         if (hook in registry) {\n                           result = registry[hook].reduce(function (previousResult, currentAction) {\n                             call_args[0] = previousResult;\n                             var interimResult = currentAction.apply({\n                               state: previousResult,\n                               hook: hook\n                             }, call_args);\n                             return interimResult !== undefined ? interimResult : previousResult;\n                           }, result);\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * remove an action again\n                        */\n                       function remove_hook(hook, action) {\n                         if (hook in registry) {\n                           for (var i = 0; i < registry[hook].length; i++) {\n                             if (registry[hook][i] === action) {\n                               registry[hook].splice(i, 1);\n                               break;\n                             }\n                           }\n                         }\n                       }\n                       /**\n                        * add an action to a hook\n                        */\n                       function add_hook(hook, action, position) {\n                         if (!(hook in registry)) {\n                           registry[hook] = [];\n                         }\n                         if (position === undefined) {\n                           position = registry[hook].length;\n                         }\n                         registry[hook].splice(position, 0, action);\n                       }\n\n                       /* and datetime-local? Spec says “Nah!” */\n\n                       var dates = ['datetime', 'date', 'month', 'week', 'time'];\n\n                       var plain_numbers = ['number', 'range'];\n\n                       /* everything that returns something meaningful for valueAsNumber and\n                        * can have the step attribute */\n                       var numbers = dates.concat(plain_numbers, 'datetime-local');\n\n                       /* the spec says to only check those for syntax in validity.typeMismatch.\n                        * ¯\\_(ツ)_/¯ */\n                       var type_checked = ['email', 'url'];\n\n                       /* check these for validity.badInput */\n                       var input_checked = ['email', 'date', 'month', 'week', 'time', 'datetime', 'datetime-local', 'number', 'range', 'color'];\n\n                       var text_types = ['text', 'search', 'tel', 'password'].concat(type_checked);\n\n                       /* input element types, that are candidates for the validation API.\n                        * Missing from this set are: button, hidden, menu (from <button>), reset and\n                        * the types for non-<input> elements. */\n                       var validation_candidates = ['checkbox', 'color', 'file', 'image', 'radio', 'submit'].concat(numbers, text_types);\n\n                       /* all known types of <input> */\n                       var inputs = ['button', 'hidden', 'reset'].concat(validation_candidates);\n\n                       /* apparently <select> and <textarea> have types of their own */\n                       var non_inputs = ['select-one', 'select-multiple', 'textarea'];\n\n                       /**\n                        * get the element's type in a backwards-compatible way\n                        */\n                       function get_type (element) {\n                         if (element instanceof window.HTMLTextAreaElement) {\n                           return 'textarea';\n                         } else if (element instanceof window.HTMLSelectElement) {\n                           return element.hasAttribute('multiple') ? 'select-multiple' : 'select-one';\n                         } else if (element instanceof window.HTMLButtonElement) {\n                           return (element.getAttribute('type') || 'submit').toLowerCase();\n                         } else if (element instanceof window.HTMLInputElement) {\n                           var attr = (element.getAttribute('type') || '').toLowerCase();\n                           if (attr && inputs.indexOf(attr) > -1) {\n                             return attr;\n                           } else {\n                             /* perhaps the DOM has in-depth knowledge. Take that before returning\n                              * 'text'. */\n                             return element.type || 'text';\n                           }\n                         }\n\n                         return '';\n                       }\n\n                       /**\n                        * check if an element should be ignored due to any of its parents\n                        *\n                        * Checks <fieldset disabled> and <datalist>.\n                        */\n                       function is_in_disallowed_parent(element) {\n                         var p = element.parentNode;\n                         while (p && p.nodeType === 1) {\n                           if (p instanceof window.HTMLFieldSetElement && p.hasAttribute('disabled')) {\n                             /* quick return, if it's a child of a disabled fieldset */\n                             return true;\n                           } else if (p.nodeName.toUpperCase() === 'DATALIST') {\n                             /* quick return, if it's a child of a datalist\n                              * Do not use HTMLDataListElement to support older browsers,\n                              * too.\n                              * @see https://html.spec.whatwg.org/multipage/forms.html#the-datalist-element:barred-from-constraint-validation\n                              */\n                             return true;\n                           } else if (p === element.form) {\n                             /* the outer boundary. We can stop looking for relevant elements. */\n                             break;\n                           }\n                           p = p.parentNode;\n                         }\n                         return false;\n                       }\n\n                       /**\n                        * check if an element is a candidate for constraint validation\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#barred-from-constraint-validation\n                        */\n                       function is_validation_candidate (element) {\n\n                         /* allow a shortcut via filters, e.g. to validate type=hidden fields */\n                         var filtered = do_filter('is_validation_candidate', null, element);\n                         if (filtered !== null) {\n                           return !!filtered;\n                         }\n\n                         /* it must be any of those elements */\n                         if (element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement) {\n\n                           var type = get_type(element);\n                           /* its type must be in the whitelist */\n                           if (non_inputs.indexOf(type) > -1 || validation_candidates.indexOf(type) > -1) {\n\n                             /* it mustn't be disabled or readonly */\n                             if (!element.hasAttribute('disabled') && !element.hasAttribute('readonly')) {\n\n                               var wrapped_form = get_wrapper(element);\n\n                               if (\n                               /* the parent form doesn't allow non-standard \"novalidate\" attributes... */\n                               wrapped_form && !wrapped_form.settings.novalidateOnElements ||\n                               /* ...or it doesn't have such an attribute/property */\n                               !element.hasAttribute('novalidate') && !element.noValidate) {\n\n                                 /* it isn't part of a <fieldset disabled> */\n                                 if (!is_in_disallowed_parent(element)) {\n\n                                   /* then it's a candidate */\n                                   return true;\n                                 }\n                               }\n                             }\n                           }\n                         }\n\n                         /* this is no HTML5 validation candidate... */\n                         return false;\n                       }\n\n                       function format_date (date) {\n                         var part = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         switch (part) {\n                           case 'date':\n                             return (date.toLocaleDateString || date.toDateString).call(date);\n                           case 'time':\n                             return (date.toLocaleTimeString || date.toTimeString).call(date);\n                           case 'month':\n                             return 'toLocaleDateString' in date ? date.toLocaleDateString(undefined, {\n                               year: 'numeric',\n                               month: '2-digit'\n                             }) : date.toDateString();\n                           // case 'week':\n                           // TODO\n                           default:\n                             return (date.toLocaleString || date.toString).call(date);\n                         }\n                       }\n\n                       function sprintf (str) {\n                         for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n                           args[_key - 1] = arguments[_key];\n                         }\n\n                         var args_length = args.length;\n                         var global_index = 0;\n\n                         return str.replace(/%([0-9]+\\$)?([sl])/g, function (match, position, type) {\n                           var local_index = global_index;\n                           if (position) {\n                             local_index = Number(position.replace(/\\$$/, '')) - 1;\n                           }\n                           global_index += 1;\n\n                           var arg = '';\n                           if (args_length > local_index) {\n                             arg = args[local_index];\n                           }\n\n                           if (arg instanceof Date || typeof arg === 'number' || arg instanceof Number) {\n                             /* try getting a localized representation of dates and numbers, if the\n                              * browser supports this */\n                             if (type === 'l') {\n                               arg = (arg.toLocaleString || arg.toString).call(arg);\n                             } else {\n                               arg = arg.toString();\n                             }\n                           }\n\n                           return arg;\n                         });\n                       }\n\n                       /* For a given date, get the ISO week number\n                        *\n                        * Source: http://stackoverflow.com/a/6117889/113195\n                        *\n                        * Based on information at:\n                        *\n                        *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR\n                        *\n                        * Algorithm is to find nearest thursday, it's year\n                        * is the year of the week number. Then get weeks\n                        * between that date and the first day of that year.\n                        *\n                        * Note that dates in one year can be weeks of previous\n                        * or next year, overlap is up to 3 days.\n                        *\n                        * e.g. 2014/12/29 is Monday in week  1 of 2015\n                        *      2012/1/1   is Sunday in week 52 of 2011\n                        */\n\n                       function get_week_of_year (d) {\n                         /* Copy date so don't modify original */\n                         d = new Date(+d);\n                         d.setUTCHours(0, 0, 0);\n                         /* Set to nearest Thursday: current date + 4 - current day number\n                          * Make Sunday's day number 7 */\n                         d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));\n                         /* Get first day of year */\n                         var yearStart = new Date(d.getUTCFullYear(), 0, 1);\n                         /* Calculate full weeks to nearest Thursday */\n                         var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);\n                         /* Return array of year and week number */\n                         return [d.getUTCFullYear(), weekNo];\n                       }\n\n                       function pad(num) {\n                         var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;\n\n                         var s = num + '';\n                         while (s.length < size) {\n                           s = '0' + s;\n                         }\n                         return s;\n                       }\n\n                       /**\n                        * calculate a string from a date according to HTML5\n                        */\n                       function date_to_string(date, element_type) {\n                         if (!(date instanceof Date)) {\n                           return null;\n                         }\n\n                         switch (element_type) {\n                           case 'datetime':\n                             return date_to_string(date, 'date') + 'T' + date_to_string(date, 'time');\n\n                           case 'datetime-local':\n                             return sprintf('%s-%s-%sT%s:%s:%s.%s', date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate()), pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds()), pad(date.getMilliseconds(), 3)).replace(/(:00)?\\.000$/, '');\n\n                           case 'date':\n                             return sprintf('%s-%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1), pad(date.getUTCDate()));\n\n                           case 'month':\n                             return sprintf('%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1));\n\n                           case 'week':\n                             var params = get_week_of_year(date);\n                             return sprintf.call(null, '%s-W%s', params[0], pad(params[1]));\n\n                           case 'time':\n                             return sprintf('%s:%s:%s.%s', pad(date.getUTCHours()), pad(date.getUTCMinutes()), pad(date.getUTCSeconds()), pad(date.getUTCMilliseconds(), 3)).replace(/(:00)?\\.000$/, '');\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * return a new Date() representing the ISO date for a week number\n                        *\n                        * @see http://stackoverflow.com/a/16591175/113195\n                        */\n\n                       function get_date_from_week (week, year) {\n                         var date = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));\n\n                         if (date.getUTCDay() <= 4 /* thursday */) {\n                             date.setUTCDate(date.getUTCDate() - date.getUTCDay() + 1);\n                           } else {\n                           date.setUTCDate(date.getUTCDate() + 8 - date.getUTCDay());\n                         }\n\n                         return date;\n                       }\n\n                       /**\n                        * calculate a date from a string according to HTML5\n                        */\n                       function string_to_date (string, element_type) {\n                         var date = new Date(0);\n                         var ms;\n                         switch (element_type) {\n                           case 'datetime':\n                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(string)) {\n                               return null;\n                             }\n                             ms = RegExp.$7 || '000';\n                             while (ms.length < 3) {\n                               ms += '0';\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));\n                             date.setUTCHours(Number(RegExp.$4), Number(RegExp.$5), Number(RegExp.$6 || 0), Number(ms));\n                             return date;\n\n                           case 'date':\n                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})$/.test(string)) {\n                               return null;\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));\n                             return date;\n\n                           case 'month':\n                             if (!/^([0-9]{4,})-([0-9]{2})$/.test(string)) {\n                               return null;\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, 1);\n                             return date;\n\n                           case 'week':\n                             if (!/^([0-9]{4,})-W(0[1-9]|[1234][0-9]|5[0-3])$/.test(string)) {\n                               return null;\n                             }\n                             return get_date_from_week(Number(RegExp.$2), Number(RegExp.$1));\n\n                           case 'time':\n                             if (!/^([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(string)) {\n                               return null;\n                             }\n                             ms = RegExp.$4 || '000';\n                             while (ms.length < 3) {\n                               ms += '0';\n                             }\n                             date.setUTCHours(Number(RegExp.$1), Number(RegExp.$2), Number(RegExp.$3 || 0), Number(ms));\n                             return date;\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * calculate a date from a string according to HTML5\n                        */\n                       function string_to_number (string, element_type) {\n                         var rval = string_to_date(string, element_type);\n                         if (rval !== null) {\n                           return +rval;\n                         }\n                         /* not parseFloat, because we want NaN for invalid values like \"1.2xxy\" */\n                         return Number(string);\n                       }\n\n                       /**\n                        * the following validation messages are from Firefox source,\n                        * http://mxr.mozilla.org/mozilla-central/source/dom/locales/en-US/chrome/dom/dom.properties\n                        * released under MPL license, http://mozilla.org/MPL/2.0/.\n                        */\n\n                       var catalog = {\n                         en: {\n                           TextTooLong: 'Please shorten this text to %l characters or less (you are currently using %l characters).',\n                           ValueMissing: 'Please fill out this field.',\n                           CheckboxMissing: 'Please check this box if you want to proceed.',\n                           RadioMissing: 'Please select one of these options.',\n                           FileMissing: 'Please select a file.',\n                           SelectMissing: 'Please select an item in the list.',\n                           InvalidEmail: 'Please enter an email address.',\n                           InvalidURL: 'Please enter a URL.',\n                           PatternMismatch: 'Please match the requested format.',\n                           PatternMismatchWithTitle: 'Please match the requested format: %l.',\n                           NumberRangeOverflow: 'Please select a value that is no more than %l.',\n                           DateRangeOverflow: 'Please select a value that is no later than %l.',\n                           TimeRangeOverflow: 'Please select a value that is no later than %l.',\n                           NumberRangeUnderflow: 'Please select a value that is no less than %l.',\n                           DateRangeUnderflow: 'Please select a value that is no earlier than %l.',\n                           TimeRangeUnderflow: 'Please select a value that is no earlier than %l.',\n                           StepMismatch: 'Please select a valid value. The two nearest valid values are %l and %l.',\n                           StepMismatchOneValue: 'Please select a valid value. The nearest valid value is %l.',\n                           BadInputNumber: 'Please enter a number.'\n                         }\n                       };\n\n                       /**\n                        * the global language Hyperform will use\n                        */\n                       var language = 'en';\n\n                       /**\n                        * the base language according to BCP47, i.e., only the piece before the first hyphen\n                        */\n                       var base_lang = 'en';\n\n                       /**\n                        * set the language for Hyperform’s messages\n                        */\n                       function set_language(newlang) {\n                         language = newlang;\n                         base_lang = newlang.replace(/[-_].*/, '');\n                       }\n\n                       /**\n                        * add a lookup catalog \"string: translation\" for a language\n                        */\n                       function add_translation(lang, new_catalog) {\n                         if (!(lang in catalog)) {\n                           catalog[lang] = {};\n                         }\n                         for (var key in new_catalog) {\n                           if (new_catalog.hasOwnProperty(key)) {\n                             catalog[lang][key] = new_catalog[key];\n                           }\n                         }\n                       }\n\n                       /**\n                        * return `s` translated into the current language\n                        *\n                        * Defaults to the base language and then English if the former has no\n                        * translation for `s`.\n                        */\n                       function _ (s) {\n                         if (language in catalog && s in catalog[language]) {\n                           return catalog[language][s];\n                         } else if (base_lang in catalog && s in catalog[base_lang]) {\n                           return catalog[base_lang][s];\n                         } else if (s in catalog.en) {\n                           return catalog.en[s];\n                         }\n                         return s;\n                       }\n\n                       var default_step = {\n                         'datetime-local': 60,\n                         datetime: 60,\n                         time: 60\n                       };\n\n                       var step_scale_factor = {\n                         'datetime-local': 1000,\n                         datetime: 1000,\n                         date: 86400000,\n                         week: 604800000,\n                         time: 1000\n                       };\n\n                       var default_step_base = {\n                         week: -259200000\n                       };\n\n                       var default_min = {\n                         range: 0\n                       };\n\n                       var default_max = {\n                         range: 100\n                       };\n\n                       /**\n                        * get previous and next valid values for a stepped input element\n                        */\n                       function get_next_valid (element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         var type = get_type(element);\n\n                         var aMin = element.getAttribute('min');\n                         var min = default_min[type] || NaN;\n                         if (aMin) {\n                           var pMin = string_to_number(aMin, type);\n                           if (!isNaN(pMin)) {\n                             min = pMin;\n                           }\n                         }\n\n                         var aMax = element.getAttribute('max');\n                         var max = default_max[type] || NaN;\n                         if (aMax) {\n                           var pMax = string_to_number(aMax, type);\n                           if (!isNaN(pMax)) {\n                             max = pMax;\n                           }\n                         }\n\n                         var aStep = element.getAttribute('step');\n                         var step = default_step[type] || 1;\n                         if (aStep && aStep.toLowerCase() === 'any') {\n                           /* quick return: we cannot calculate prev and next */\n                           return [_('any value'), _('any value')];\n                         } else if (aStep) {\n                           var pStep = string_to_number(aStep, type);\n                           if (!isNaN(pStep)) {\n                             step = pStep;\n                           }\n                         }\n\n                         var default_value = string_to_number(element.getAttribute('value'), type);\n\n                         var value = string_to_number(element.value || element.getAttribute('value'), type);\n\n                         if (isNaN(value)) {\n                           /* quick return: we cannot calculate without a solid base */\n                           return [_('any valid value'), _('any valid value')];\n                         }\n\n                         var step_base = !isNaN(min) ? min : !isNaN(default_value) ? default_value : default_step_base[type] || 0;\n\n                         var scale = step_scale_factor[type] || 1;\n\n                         var prev = step_base + Math.floor((value - step_base) / (step * scale)) * (step * scale) * n;\n                         var next = step_base + (Math.floor((value - step_base) / (step * scale)) + 1) * (step * scale) * n;\n\n                         if (prev < min) {\n                           prev = null;\n                         } else if (prev > max) {\n                           prev = max;\n                         }\n\n                         if (next > max) {\n                           next = null;\n                         } else if (next < min) {\n                           next = min;\n                         }\n\n                         /* convert to date objects, if appropriate */\n                         if (dates.indexOf(type) > -1) {\n                           prev = date_to_string(new Date(prev), type);\n                           next = date_to_string(new Date(next), type);\n                         }\n\n                         return [prev, next];\n                       }\n\n                       /**\n                        * patch String.length to account for non-BMP characters\n                        *\n                        * @see https://mathiasbynens.be/notes/javascript-unicode\n                        * We do not use the simple [...str].length, because it needs a ton of\n                        * polyfills in older browsers.\n                        */\n\n                       function unicode_string_length (str) {\n                         return str.match(/[\\0-\\uD7FF\\uE000-\\uFFFF]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\uD800-\\uDBFF](?![\\uDC00-\\uDFFF])|(?:[^\\uD800-\\uDBFF]|^)[\\uDC00-\\uDFFF]/g).length;\n                       }\n\n                       /**\n                        * internal storage for custom error messages\n                        */\n\n                       var store$1 = new WeakMap();\n\n                       /**\n                        * register custom error messages per element\n                        */\n                       var custom_messages = {\n                         set: function set(element, validator, message) {\n                           var messages = store$1.get(element) || {};\n                           messages[validator] = message;\n                           store$1.set(element, messages);\n                           return custom_messages;\n                         },\n                         get: function get(element, validator) {\n                           var _default = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;\n\n                           var messages = store$1.get(element);\n                           if (messages === undefined || !(validator in messages)) {\n                             var data_id = 'data-' + validator.replace(/[A-Z]/g, '-$&').toLowerCase();\n                             if (element.hasAttribute(data_id)) {\n                               /* if the element has a data-validator attribute, use this as fallback.\n                                * E.g., if validator == 'valueMissing', the element can specify a\n                                * custom validation message like this:\n                                *     <input data-value-missing=\"Oh noes!\">\n                                */\n                               return element.getAttribute(data_id);\n                             }\n                             return _default;\n                           }\n                           return messages[validator];\n                         },\n                         delete: function _delete(element) {\n                           var validator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;\n\n                           if (!validator) {\n                             return store$1.delete(element);\n                           }\n                           var messages = store$1.get(element) || {};\n                           if (validator in messages) {\n                             delete messages[validator];\n                             store$1.set(element, messages);\n                             return true;\n                           }\n                           return false;\n                         }\n                       };\n\n                       var internal_registry = new WeakMap();\n\n                       /**\n                        * A registry for custom validators\n                        *\n                        * slim wrapper around a WeakMap to ensure the values are arrays\n                        * (hence allowing > 1 validators per element)\n                        */\n                       var custom_validator_registry = {\n                         set: function set(element, validator) {\n                           var current = internal_registry.get(element) || [];\n                           current.push(validator);\n                           internal_registry.set(element, current);\n                           return custom_validator_registry;\n                         },\n                         get: function get(element) {\n                           return internal_registry.get(element) || [];\n                         },\n                         delete: function _delete(element) {\n                           return internal_registry.delete(element);\n                         }\n                       };\n\n                       /**\n                        * test whether the element suffers from bad input\n                        */\n                       function test_bad_input (element) {\n                         var type = get_type(element);\n\n                         if (input_checked.indexOf(type) === -1) {\n                           /* we're not interested, thanks! */\n                           return true;\n                         }\n\n                         /* the browser hides some bad input from the DOM, e.g. malformed numbers,\n                          * email addresses with invalid punycode representation, ... We try to resort\n                          * to the original method here. The assumption is, that a browser hiding\n                          * bad input will hopefully also always support a proper\n                          * ValidityState.badInput */\n                         if (!element.value) {\n                           if ('_original_validity' in element && !element._original_validity.__hyperform) {\n                             return !element._original_validity.badInput;\n                           }\n                           /* no value and no original badInput: Assume all's right. */\n                           return true;\n                         }\n\n                         var result = true;\n                         switch (type) {\n                           case 'color':\n                             result = /^#[a-f0-9]{6}$/.test(element.value);\n                             break;\n                           case 'number':\n                           case 'range':\n                             result = !isNaN(Number(element.value));\n                             break;\n                           case 'datetime':\n                           case 'date':\n                           case 'month':\n                           case 'week':\n                           case 'time':\n                             result = string_to_date(element.value, type) !== null;\n                             break;\n                           case 'datetime-local':\n                             result = /^([0-9]{4,})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(element.value);\n                             break;\n                           case 'tel':\n                             /* spec says No! Phone numbers can have all kinds of formats, so this\n                              * is expected to be a free-text field. */\n                             // TODO we could allow a setting 'phone_regex' to be evaluated here.\n                             break;\n                           case 'email':\n                             break;\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * test the max attribute\n                        *\n                        * we use Number() instead of parseFloat(), because an invalid attribute\n                        * value like \"123abc\" should result in an error.\n                        */\n                       function test_max (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || !element.hasAttribute('max')) {\n                           /* we're not responsible here */\n                           return true;\n                         }\n\n                         var value = void 0,\n                             max = void 0;\n                         if (dates.indexOf(type) > -1) {\n                           value = 1 * string_to_date(element.value, type);\n                           max = 1 * (string_to_date(element.getAttribute('max'), type) || NaN);\n                         } else {\n                           value = Number(element.value);\n                           max = Number(element.getAttribute('max'));\n                         }\n\n                         return isNaN(max) || value <= max;\n                       }\n\n                       /**\n                        * test the maxlength attribute\n                        */\n                       function test_maxlength (element) {\n                         if (!element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('maxlength') || !element.getAttribute('maxlength') // catch maxlength=\"\"\n                         ) {\n                             return true;\n                           }\n\n                         var maxlength = parseInt(element.getAttribute('maxlength'), 10);\n\n                         /* check, if the maxlength value is usable at all.\n                          * We allow maxlength === 0 to basically disable input (Firefox does, too).\n                          */\n                         if (isNaN(maxlength) || maxlength < 0) {\n                           return true;\n                         }\n\n                         return unicode_string_length(element.value) <= maxlength;\n                       }\n\n                       /**\n                        * test the min attribute\n                        *\n                        * we use Number() instead of parseFloat(), because an invalid attribute\n                        * value like \"123abc\" should result in an error.\n                        */\n                       function test_min (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || !element.hasAttribute('min')) {\n                           /* we're not responsible here */\n                           return true;\n                         }\n\n                         var value = void 0,\n                             min = void 0;\n                         if (dates.indexOf(type) > -1) {\n                           value = 1 * string_to_date(element.value, type);\n                           min = 1 * (string_to_date(element.getAttribute('min'), type) || NaN);\n                         } else {\n                           value = Number(element.value);\n                           min = Number(element.getAttribute('min'));\n                         }\n\n                         return isNaN(min) || value >= min;\n                       }\n\n                       /**\n                        * test the minlength attribute\n                        */\n                       function test_minlength (element) {\n                         if (!element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('minlength') || !element.getAttribute('minlength') // catch minlength=\"\"\n                         ) {\n                             return true;\n                           }\n\n                         var minlength = parseInt(element.getAttribute('minlength'), 10);\n\n                         /* check, if the minlength value is usable at all. */\n                         if (isNaN(minlength) || minlength < 0) {\n                           return true;\n                         }\n\n                         return unicode_string_length(element.value) >= minlength;\n                       }\n\n                       /**\n                        * test the pattern attribute\n                        */\n\n                       function test_pattern (element) {\n                           return !element.value || !element.hasAttribute('pattern') || new RegExp('^(?:' + element.getAttribute('pattern') + ')$').test(element.value);\n                       }\n\n                       function has_submittable_option(select) {\n                         return Array.prototype.some.call(select.options, function (option) {\n                           return option.selected && !option.disabled;\n                         });\n                       }\n\n                       /**\n                        * test the required attribute\n                        */\n                       function test_required (element) {\n                         if (element.type === 'radio') {\n                           /* the happy (and quick) path for radios: */\n                           if (element.hasAttribute('required') && element.checked) {\n                             return true;\n                           }\n\n                           var radiogroup = get_radiogroup(element);\n\n                           /* if any radio in the group is required, we need any (not necessarily the\n                            * same) radio to be checked */\n                           if (radiogroup.some(function (radio) {\n                             return radio.hasAttribute('required');\n                           })) {\n                             return radiogroup.some(function (radio) {\n                               return radio.checked;\n                             });\n                           }\n                           /* not required, validation passes */\n                           return true;\n                         }\n\n                         if (!element.hasAttribute('required')) {\n                           /* nothing to do */\n                           return true;\n                         }\n\n                         if (element instanceof window.HTMLSelectElement) {\n                           return has_submittable_option(element);\n                         }\n\n                         return element.type === 'checkbox' ? element.checked : !!element.value;\n                       }\n\n                       /**\n                        * test the step attribute\n                        */\n                       function test_step (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || numbers.indexOf(type) === -1 || (element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           /* we're not responsible here. Note: If no step attribute is given, we\n                            * need to validate against the default step as per spec. */\n                           return true;\n                         }\n\n                         var step = element.getAttribute('step');\n                         if (step) {\n                           step = string_to_number(step, type);\n                         } else {\n                           step = default_step[type] || 1;\n                         }\n\n                         if (step <= 0 || isNaN(step)) {\n                           /* error in specified \"step\". We cannot validate against it, so the value\n                            * is true. */\n                           return true;\n                         }\n\n                         var scale = step_scale_factor[type] || 1;\n\n                         var value = string_to_number(element.value, type);\n                         var min = string_to_number(element.getAttribute('min') || element.getAttribute('value') || '', type);\n\n                         if (isNaN(min)) {\n                           min = default_step_base[type] || 0;\n                         }\n\n                         if (type === 'month') {\n                           /* type=month has month-wide steps. See\n                            * https://html.spec.whatwg.org/multipage/forms.html#month-state-%28type=month%29\n                            */\n                           min = new Date(min).getUTCFullYear() * 12 + new Date(min).getUTCMonth();\n                           value = new Date(value).getUTCFullYear() * 12 + new Date(value).getUTCMonth();\n                         }\n\n                         var result = Math.abs(min - value) % (step * scale);\n\n                         return result < 0.00000001 ||\n                         /* crappy floating-point arithmetics! */\n                         result > step * scale - 0.00000001;\n                       }\n\n                       var ws_on_start_or_end = /^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g;\n\n                       /**\n                        * trim a string of whitespace\n                        *\n                        * We don't use String.trim() to remove the need to polyfill it.\n                        */\n                       function trim (str) {\n                         return str.replace(ws_on_start_or_end, '');\n                       }\n\n                       /**\n                        * split a string on comma and trim the components\n                        *\n                        * As specified at\n                        * https://html.spec.whatwg.org/multipage/infrastructure.html#split-a-string-on-commas\n                        * plus removing empty entries.\n                        */\n                       function comma_split (str) {\n                         return str.split(',').map(function (item) {\n                           return trim(item);\n                         }).filter(function (b) {\n                           return b;\n                         });\n                       }\n\n                       /* we use a dummy <a> where we set the href to test URL validity\n                        * The definition is out of the \"global\" scope so that JSDOM can be instantiated\n                        * after loading Hyperform for tests.\n                        */\n                       var url_canary;\n\n                       /* see https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address */\n                       var email_pattern = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;\n\n                       /**\n                        * test the type-inherent syntax\n                        */\n                       function test_type (element) {\n                         var type = get_type(element);\n\n                         if (type !== 'file' && !element.value || type !== 'file' && type_checked.indexOf(type) === -1) {\n                           /* we're not responsible for this element */\n                           return true;\n                         }\n\n                         var is_valid = true;\n\n                         switch (type) {\n                           case 'url':\n                             if (!url_canary) {\n                               url_canary = document.createElement('a');\n                             }\n                             var value = trim(element.value);\n                             url_canary.href = value;\n                             is_valid = url_canary.href === value || url_canary.href === value + '/';\n                             break;\n                           case 'email':\n                             if (element.hasAttribute('multiple')) {\n                               is_valid = comma_split(element.value).every(function (value) {\n                                 return email_pattern.test(value);\n                               });\n                             } else {\n                               is_valid = email_pattern.test(trim(element.value));\n                             }\n                             break;\n                           case 'file':\n                             if ('files' in element && element.files.length && element.hasAttribute('accept')) {\n                               var patterns = comma_split(element.getAttribute('accept')).map(function (pattern) {\n                                 if (/^(audio|video|image)\\/\\*$/.test(pattern)) {\n                                   pattern = new RegExp('^' + RegExp.$1 + '/.+$');\n                                 }\n                                 return pattern;\n                               });\n\n                               if (!patterns.length) {\n                                 break;\n                               }\n\n                               fileloop: for (var i = 0; i < element.files.length; i++) {\n                                 /* we need to match a whitelist, so pre-set with false */\n                                 var file_valid = false;\n\n                                 patternloop: for (var j = 0; j < patterns.length; j++) {\n                                   var file = element.files[i];\n                                   var pattern = patterns[j];\n\n                                   var fileprop = file.type;\n\n                                   if (typeof pattern === 'string' && pattern.substr(0, 1) === '.') {\n                                     if (file.name.search('.') === -1) {\n                                       /* no match with any file ending */\n                                       continue patternloop;\n                                     }\n\n                                     fileprop = file.name.substr(file.name.lastIndexOf('.'));\n                                   }\n\n                                   if (fileprop.search(pattern) === 0) {\n                                     /* we found one match and can quit looking */\n                                     file_valid = true;\n                                     break patternloop;\n                                   }\n                                 }\n\n                                 if (!file_valid) {\n                                   is_valid = false;\n                                   break fileloop;\n                                 }\n                               }\n                             }\n                         }\n\n                         return is_valid;\n                       }\n\n                       /**\n                        * boilerplate function for all tests but customError\n                        */\n                       function check$1(test, react) {\n                         return function (element) {\n                           var invalid = !test(element);\n                           if (invalid) {\n                             react(element);\n                           }\n                           return invalid;\n                         };\n                       }\n\n                       /**\n                        * create a common function to set error messages\n                        */\n                       function set_msg(element, msgtype, _default) {\n                         message_store.set(element, custom_messages.get(element, msgtype, _default));\n                       }\n\n                       var badInput = check$1(test_bad_input, function (element) {\n                         return set_msg(element, 'badInput', _('Please match the requested type.'));\n                       });\n\n                       function customError(element) {\n                         /* prevent infinite loops when the custom validators call setCustomValidity(),\n                          * which in turn calls this code again. We check, if there is an already set\n                          * custom validity message there. */\n                         if (element.__hf_custom_validation_running) {\n                           var msg = message_store.get(element);\n                           return msg && msg.is_custom;\n                         }\n\n                         /* check, if there are custom validators in the registry, and call\n                          * them. */\n                         var custom_validators = custom_validator_registry.get(element);\n                         var cvl = custom_validators.length;\n                         var valid = true;\n\n                         if (cvl) {\n                           element.__hf_custom_validation_running = true;\n                           for (var i = 0; i < cvl; i++) {\n                             var result = custom_validators[i](element);\n                             if (result !== undefined && !result) {\n                               valid = false;\n                               /* break on first invalid response */\n                               break;\n                             }\n                           }\n                           delete element.__hf_custom_validation_running;\n                         }\n\n                         /* check, if there are other validity messages already */\n                         if (valid) {\n                           var _msg = message_store.get(element);\n                           valid = !(_msg.toString() && 'is_custom' in _msg);\n                         }\n\n                         return !valid;\n                       }\n\n                       var patternMismatch = check$1(test_pattern, function (element) {\n                         set_msg(element, 'patternMismatch', element.title ? sprintf(_('PatternMismatchWithTitle'), element.title) : _('PatternMismatch'));\n                       });\n\n                       /**\n                        * TODO: when rangeOverflow and rangeUnderflow are both called directly and\n                        * successful, the inRange and outOfRange classes won't get removed, unless\n                        * element.validityState.valid is queried, too.\n                        */\n                       var rangeOverflow = check$1(test_max, function (element) {\n                         var type = get_type(element);\n                         var wrapper = get_wrapper(element);\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n\n                         var msg = void 0;\n\n                         switch (type) {\n                           case 'date':\n                           case 'datetime':\n                           case 'datetime-local':\n                             msg = sprintf(_('DateRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));\n                             break;\n                           case 'time':\n                             msg = sprintf(_('TimeRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));\n                             break;\n                           // case 'number':\n                           default:\n                             msg = sprintf(_('NumberRangeOverflow'), string_to_number(element.getAttribute('max'), type));\n                             break;\n                         }\n\n                         set_msg(element, 'rangeOverflow', msg);\n                         element.classList.add(outOfRangeClass);\n                         element.classList.remove(inRangeClass);\n                       });\n\n                       var rangeUnderflow = check$1(test_min, function (element) {\n                         var type = get_type(element);\n                         var wrapper = get_wrapper(element);\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n\n                         var msg = void 0;\n\n                         switch (type) {\n                           case 'date':\n                           case 'datetime':\n                           case 'datetime-local':\n                             msg = sprintf(_('DateRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));\n                             break;\n                           case 'time':\n                             msg = sprintf(_('TimeRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));\n                             break;\n                           // case 'number':\n                           default:\n                             msg = sprintf(_('NumberRangeUnderflow'), string_to_number(element.getAttribute('min'), type));\n                             break;\n                         }\n\n                         set_msg(element, 'rangeUnderflow', msg);\n                         element.classList.add(outOfRangeClass);\n                         element.classList.remove(inRangeClass);\n                       });\n\n                       var stepMismatch = check$1(test_step, function (element) {\n                         var list = get_next_valid(element);\n                         var min = list[0];\n                         var max = list[1];\n                         var sole = false;\n                         var msg = void 0;\n\n                         if (min === null) {\n                           sole = max;\n                         } else if (max === null) {\n                           sole = min;\n                         }\n\n                         if (sole !== false) {\n                           msg = sprintf(_('StepMismatchOneValue'), sole);\n                         } else {\n                           msg = sprintf(_('StepMismatch'), min, max);\n                         }\n                         set_msg(element, 'stepMismatch', msg);\n                       });\n\n                       var tooLong = check$1(test_maxlength, function (element) {\n                         set_msg(element, 'tooLong', sprintf(_('TextTooLong'), element.getAttribute('maxlength'), unicode_string_length(element.value)));\n                       });\n\n                       var tooShort = check$1(test_minlength, function (element) {\n                         set_msg(element, 'tooShort', sprintf(_('Please lengthen this text to %l characters or more (you are currently using %l characters).'), element.getAttribute('minlength'), unicode_string_length(element.value)));\n                       });\n\n                       var typeMismatch = check$1(test_type, function (element) {\n                         var msg = _('Please use the appropriate format.');\n                         var type = get_type(element);\n\n                         if (type === 'email') {\n                           if (element.hasAttribute('multiple')) {\n                             msg = _('Please enter a comma separated list of email addresses.');\n                           } else {\n                             msg = _('InvalidEmail');\n                           }\n                         } else if (type === 'url') {\n                           msg = _('InvalidURL');\n                         } else if (type === 'file') {\n                           msg = _('Please select a file of the correct type.');\n                         }\n\n                         set_msg(element, 'typeMismatch', msg);\n                       });\n\n                       var valueMissing = check$1(test_required, function (element) {\n                         var msg = _('ValueMissing');\n                         var type = get_type(element);\n\n                         if (type === 'checkbox') {\n                           msg = _('CheckboxMissing');\n                         } else if (type === 'radio') {\n                           msg = _('RadioMissing');\n                         } else if (type === 'file') {\n                           if (element.hasAttribute('multiple')) {\n                             msg = _('Please select one or more files.');\n                           } else {\n                             msg = _('FileMissing');\n                           }\n                         } else if (element instanceof window.HTMLSelectElement) {\n                           msg = _('SelectMissing');\n                         }\n\n                         set_msg(element, 'valueMissing', msg);\n                       });\n\n                       /**\n                        * the \"valid\" property calls all other validity checkers and returns true,\n                        * if all those return false.\n                        *\n                        * This is the major access point for _all_ other API methods, namely\n                        * (check|report)Validity().\n                        */\n                       var valid = function valid(element) {\n                         var wrapper = get_wrapper(element);\n                         var validClass = wrapper && wrapper.settings.classes.valid || 'hf-valid';\n                         var invalidClass = wrapper && wrapper.settings.classes.invalid || 'hf-invalid';\n                         var userInvalidClass = wrapper && wrapper.settings.classes.userInvalid || 'hf-user-invalid';\n                         var userValidClass = wrapper && wrapper.settings.classes.userValid || 'hf-user-valid';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var validatedClass = wrapper && wrapper.settings.classes.validated || 'hf-validated';\n\n                         element.classList.add(validatedClass);\n\n                         var _arr = [badInput, customError, patternMismatch, rangeOverflow, rangeUnderflow, stepMismatch, tooLong, tooShort, typeMismatch, valueMissing];\n                         for (var _i = 0; _i < _arr.length; _i++) {\n                           var checker = _arr[_i];\n                           if (checker(element)) {\n                             element.classList.add(invalidClass);\n                             element.classList.remove(validClass);\n                             element.classList.remove(userValidClass);\n                             if (element.value !== element.defaultValue) {\n                               element.classList.add(userInvalidClass);\n                             } else {\n                               element.classList.remove(userInvalidClass);\n                             }\n                             element.setAttribute('aria-invalid', 'true');\n                             return false;\n                           }\n                         }\n\n                         message_store.delete(element);\n                         element.classList.remove(invalidClass);\n                         element.classList.remove(userInvalidClass);\n                         element.classList.remove(outOfRangeClass);\n                         element.classList.add(validClass);\n                         element.classList.add(inRangeClass);\n                         if (element.value !== element.defaultValue) {\n                           element.classList.add(userValidClass);\n                         } else {\n                           element.classList.remove(userValidClass);\n                         }\n                         element.setAttribute('aria-invalid', 'false');\n                         return true;\n                       };\n\n                       var validity_state_checkers = {\n                         badInput: badInput,\n                         customError: customError,\n                         patternMismatch: patternMismatch,\n                         rangeOverflow: rangeOverflow,\n                         rangeUnderflow: rangeUnderflow,\n                         stepMismatch: stepMismatch,\n                         tooLong: tooLong,\n                         tooShort: tooShort,\n                         typeMismatch: typeMismatch,\n                         valueMissing: valueMissing,\n                         valid: valid\n                       };\n\n                       /**\n                        * the validity state constructor\n                        */\n                       var ValidityState = function ValidityState(element) {\n                         if (!(element instanceof window.HTMLElement)) {\n                           throw new Error('cannot create a ValidityState for a non-element');\n                         }\n\n                         var cached = ValidityState.cache.get(element);\n                         if (cached) {\n                           return cached;\n                         }\n\n                         if (!(this instanceof ValidityState)) {\n                           /* working around a forgotten `new` */\n                           return new ValidityState(element);\n                         }\n\n                         this.element = element;\n                         ValidityState.cache.set(element, this);\n                       };\n\n                       /**\n                        * the prototype for new validityState instances\n                        */\n                       var ValidityStatePrototype = {};\n                       ValidityState.prototype = ValidityStatePrototype;\n\n                       ValidityState.cache = new WeakMap();\n\n                       /* small wrapper around the actual validator to check if the validator\n                        * should actually be called. `this` refers to the ValidityState object. */\n                       var checker_getter = function checker_getter(func) {\n                         return function () {\n                           if (!is_validation_candidate(this.element)) {\n                             /* not being validated == valid by default */\n                             return true;\n                           }\n                           return func(this.element);\n                         };\n                       };\n\n                       /**\n                        * copy functionality from the validity checkers to the ValidityState\n                        * prototype\n                        */\n                       for (var prop in validity_state_checkers) {\n                         Object.defineProperty(ValidityStatePrototype, prop, {\n                           configurable: true,\n                           enumerable: true,\n                           get: checker_getter(validity_state_checkers[prop]),\n                           set: undefined\n                         });\n                       }\n\n                       /**\n                        * mark the validity prototype, because that is what the client-facing\n                        * code deals with mostly, not the property descriptor thing */\n                       mark(ValidityStatePrototype);\n\n                       /**\n                        * check element's validity and report an error back to the user\n                        */\n                       function reportValidity(element) {\n                         /* if this is a <form>, report validity of all child inputs */\n                         if (element instanceof window.HTMLFormElement) {\n                           element.__hf_form_validation = true;\n                           var form_valid = get_validated_elements(element).map(reportValidity).every(function (b) {\n                             return b;\n                           });\n                           delete element.__hf_form_validation;\n                           return form_valid;\n                         }\n\n                         /* we copy checkValidity() here, b/c we have to check if the \"invalid\"\n                          * event was canceled. */\n                         var valid = ValidityState(element).valid;\n                         var event;\n                         if (valid) {\n                           var wrapped_form = get_wrapper(element);\n                           if (wrapped_form && wrapped_form.settings.validEvent) {\n                             event = trigger_event(element, 'valid', { cancelable: true });\n                           }\n                         } else {\n                           event = trigger_event(element, 'invalid', { cancelable: true });\n                         }\n\n                         if (!event || !event.defaultPrevented) {\n                           Renderer.showWarning(element, !!element.form.__hf_form_validation);\n                         }\n\n                         return valid;\n                       }\n\n                       /**\n                        * submit a form, because `element` triggered it\n                        *\n                        * This method also dispatches a submit event on the form prior to the\n                        * submission. The event contains the trigger element as `submittedVia`.\n                        *\n                        * If the element is a button with a name, the name=value pair will be added\n                        * to the submitted data.\n                        */\n                       function submit_form_via(element) {\n                         /* apparently, the submit event is not triggered in most browsers on\n                          * the submit() method, so we do it manually here to model a natural\n                          * submit as closely as possible.\n                          * Now to the fun fact: If you trigger a submit event from a form, what\n                          * do you think should happen?\n                          * 1) the form will be automagically submitted by the browser, or\n                          * 2) nothing.\n                          * And as you already suspected, the correct answer is: both! Firefox\n                          * opts for 1), Chrome for 2). Yay! */\n                         var event_got_cancelled;\n\n                         var submit_event = create_event('submit', { cancelable: true });\n                         /* force Firefox to not submit the form, then fake preventDefault() */\n                         submit_event.preventDefault();\n                         Object.defineProperty(submit_event, 'defaultPrevented', {\n                           value: false,\n                           writable: true\n                         });\n                         Object.defineProperty(submit_event, 'preventDefault', {\n                           value: function value() {\n                             return submit_event.defaultPrevented = event_got_cancelled = true;\n                           },\n                           writable: true\n                         });\n                         trigger_event(element.form, submit_event, {}, { submittedVia: element });\n\n                         if (!event_got_cancelled) {\n                           add_submit_field(element);\n                           window.HTMLFormElement.prototype.submit.call(element.form);\n                           window.setTimeout(function () {\n                             return remove_submit_field(element);\n                           });\n                         }\n                       }\n\n                       /**\n                        * if a submit button was clicked, add its name=value by means of a type=hidden\n                        * input field\n                        */\n                       function add_submit_field(button) {\n                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {\n                           var wrapper = get_wrapper(button.form) || {};\n                           var submit_helper = wrapper.submit_helper;\n                           if (submit_helper) {\n                             if (submit_helper.parentNode) {\n                               submit_helper.parentNode.removeChild(submit_helper);\n                             }\n                           } else {\n                             submit_helper = document.createElement('input');\n                             submit_helper.type = 'hidden';\n                             wrapper.submit_helper = submit_helper;\n                           }\n                           submit_helper.name = button.name;\n                           submit_helper.value = button.value;\n                           button.form.appendChild(submit_helper);\n                         }\n                       }\n\n                       /**\n                        * remove a possible helper input, that was added by `add_submit_field`\n                        */\n                       function remove_submit_field(button) {\n                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {\n                           var wrapper = get_wrapper(button.form) || {};\n                           var submit_helper = wrapper.submit_helper;\n                           if (submit_helper && submit_helper.parentNode) {\n                             submit_helper.parentNode.removeChild(submit_helper);\n                           }\n                         }\n                       }\n\n                       /**\n                        * check a form's validity and submit it\n                        *\n                        * The method triggers a cancellable `validate` event on the form. If the\n                        * event is cancelled, form submission will be aborted, too.\n                        *\n                        * If the form is found to contain invalid fields, focus the first field.\n                        */\n                       function check(button) {\n                         /* trigger a \"validate\" event on the form to be submitted */\n                         var val_event = trigger_event(button.form, 'validate', { cancelable: true });\n                         if (val_event.defaultPrevented) {\n                           /* skip the whole submit thing, if the validation is canceled. A user\n                            * can still call form.submit() afterwards. */\n                           return;\n                         }\n\n                         var valid = true;\n                         var first_invalid;\n                         button.form.__hf_form_validation = true;\n                         get_validated_elements(button.form).map(function (element) {\n                           if (!reportValidity(element)) {\n                             valid = false;\n                             if (!first_invalid && 'focus' in element) {\n                               first_invalid = element;\n                             }\n                           }\n                         });\n                         delete button.form.__hf_form_validation;\n\n                         if (valid) {\n                           submit_form_via(button);\n                         } else if (first_invalid) {\n                           /* focus the first invalid element, if validation went south */\n                           first_invalid.focus();\n                           /* tell the tale, if anyone wants to react to it */\n                           trigger_event(button.form, 'forminvalid');\n                         }\n                       }\n\n                       /**\n                        * test if node is a submit button\n                        */\n                       function is_submit_button(node) {\n                         return (\n                           /* must be an input or button element... */\n                           (node.nodeName === 'INPUT' || node.nodeName === 'BUTTON') && (\n\n                           /* ...and have a submitting type */\n                           node.type === 'image' || node.type === 'submit')\n                         );\n                       }\n\n                       /**\n                        * test, if the click event would trigger a submit\n                        */\n                       function is_submitting_click(event, button) {\n                         return (\n                           /* prevented default: won't trigger a submit */\n                           !event.defaultPrevented && (\n\n                           /* left button or middle button (submits in Chrome) */\n                           !('button' in event) || event.button < 2) &&\n\n                           /* must be a submit button... */\n                           is_submit_button(button) &&\n\n                           /* the button needs a form, that's going to be submitted */\n                           button.form &&\n\n                           /* again, if the form should not be validated, we're out of the game */\n                           !button.form.hasAttribute('novalidate')\n                         );\n                       }\n\n                       /**\n                        * test, if the keypress event would trigger a submit\n                        */\n                       function is_submitting_keypress(event) {\n                         return (\n                           /* prevented default: won't trigger a submit */\n                           !event.defaultPrevented && (\n                           /* ...and <Enter> was pressed... */\n                           event.keyCode === 13 &&\n\n                           /* ...on an <input> that is... */\n                           event.target.nodeName === 'INPUT' &&\n\n                           /* ...a standard text input field (not checkbox, ...) */\n                           text_types.indexOf(event.target.type) > -1 ||\n                           /* or <Enter> or <Space> was pressed... */\n                           (event.keyCode === 13 || event.keyCode === 32) &&\n\n                           /* ...on a submit button */\n                           is_submit_button(event.target)) &&\n\n                           /* there's a form... */\n                           event.target.form &&\n\n                           /* ...and the form allows validation */\n                           !event.target.form.hasAttribute('novalidate')\n                         );\n                       }\n\n                       /**\n                        * catch clicks to children of <button>s\n                        */\n                       function get_clicked_button(element) {\n                         if (is_submit_button(element)) {\n                           return element;\n                         } else if (matches(element, 'button:not([type]) *, button[type=\"submit\"] *')) {\n                           return get_clicked_button(element.parentNode);\n                         } else {\n                           return null;\n                         }\n                       }\n\n                       /**\n                        * return event handler to catch explicit submission by click on a button\n                        */\n                       function get_click_handler() {\n                         var ignore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;\n\n                         return function (event) {\n                           var button = get_clicked_button(event.target);\n                           if (button && is_submitting_click(event, button)) {\n                             event.preventDefault();\n                             if (ignore || button.hasAttribute('formnovalidate')) {\n                               /* if validation should be ignored, we're not interested in any checks */\n                               submit_form_via(button);\n                             } else {\n                               check(button);\n                             }\n                           }\n                         };\n                       }\n                       var click_handler = get_click_handler();\n                       var ignored_click_handler = get_click_handler(true);\n\n                       /**\n                        * catch implicit submission by pressing <Enter> in some situations\n                        */\n                       function get_keypress_handler(ignore) {\n                         return function keypress_handler(event) {\n                           if (is_submitting_keypress(event)) {\n                             event.preventDefault();\n\n                             var wrapper = get_wrapper(event.target.form) || { settings: {} };\n                             if (wrapper.settings.preventImplicitSubmit) {\n                               /* user doesn't want an implicit submit. Cancel here. */\n                               return;\n                             }\n\n                             /* check, that there is no submit button in the form. Otherwise\n                             * that should be clicked. */\n                             var el = event.target.form.elements.length;\n                             var submit;\n                             for (var i = 0; i < el; i++) {\n                               if (['image', 'submit'].indexOf(event.target.form.elements[i].type) > -1) {\n                                 submit = event.target.form.elements[i];\n                                 break;\n                               }\n                             }\n\n                             if (submit) {\n                               submit.click();\n                             } else if (ignore) {\n                               submit_form_via(event.target);\n                             } else {\n                               check(event.target);\n                             }\n                           }\n                         };\n                       }\n                       var keypress_handler = get_keypress_handler();\n                       var ignored_keypress_handler = get_keypress_handler(true);\n\n                       /**\n                        * catch all relevant events _prior_ to a form being submitted\n                        *\n                        * @param bool ignore bypass validation, when an attempt to submit the\n                        *                    form is detected. True, when the wrapper's revalidate\n                        *                    setting is 'never'.\n                        */\n                       function catch_submit(listening_node) {\n                         var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                         if (ignore) {\n                           listening_node.addEventListener('click', ignored_click_handler);\n                           listening_node.addEventListener('keypress', ignored_keypress_handler);\n                         } else {\n                           listening_node.addEventListener('click', click_handler);\n                           listening_node.addEventListener('keypress', keypress_handler);\n                         }\n                       }\n\n                       /**\n                        * decommission the event listeners from catch_submit() again\n                        */\n                       function uncatch_submit(listening_node) {\n                         listening_node.removeEventListener('click', ignored_click_handler);\n                         listening_node.removeEventListener('keypress', ignored_keypress_handler);\n                         listening_node.removeEventListener('click', click_handler);\n                         listening_node.removeEventListener('keypress', keypress_handler);\n                       }\n\n                       /**\n                        * remove `property` from element and restore _original_property, if present\n                        */\n                       function uninstall_property (element, property) {\n                         try {\n                           delete element[property];\n                         } catch (e) {\n                           /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except\n                            * warning */\n                           var wrapper = get_wrapper(element);\n                           if (wrapper && wrapper.settings.debug) {\n                             /* global console */\n                             console.log('[hyperform] cannot uninstall custom property ' + property);\n                           }\n                           return false;\n                         }\n\n                         var original_descriptor = Object.getOwnPropertyDescriptor(element, '_original_' + property);\n\n                         if (original_descriptor) {\n                           Object.defineProperty(element, property, original_descriptor);\n                         }\n                       }\n\n                       /**\n                        * add `property` to an element\n                        *\n                        * ATTENTION! This function will search for an equally named property on the\n                        * *prototype* of an element, if element is a concrete DOM node. Do not use\n                        * it as general-purpose property installer.\n                        *\n                        * js> installer(element, 'foo', { value: 'bar' });\n                        * js> assert(element.foo === 'bar');\n                        */\n                       function install_property (element, property, descriptor) {\n                         descriptor.configurable = true;\n                         descriptor.enumerable = true;\n                         if ('value' in descriptor) {\n                           descriptor.writable = true;\n                         }\n\n                         /* on concrete instances, i.e., <input> elements, the naive lookup\n                          * yields undefined. We have to look on its prototype then. On elements\n                          * like the actual HTMLInputElement object the first line works. */\n                         var original_descriptor = Object.getOwnPropertyDescriptor(element, property);\n                         if (original_descriptor === undefined) {\n                           original_descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), property);\n                         }\n\n                         if (original_descriptor) {\n\n                           if (original_descriptor.configurable === false) {\n                             /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except\n                              * warning */\n                             var wrapper = get_wrapper(element);\n                             if (wrapper && wrapper.settings.debug) {\n                               /* global console */\n                               console.log('[hyperform] cannot install custom property ' + property);\n                             }\n                             return false;\n                           }\n\n                           /* we already installed that property... */\n                           if (original_descriptor.get && original_descriptor.get.__hyperform || original_descriptor.value && original_descriptor.value.__hyperform) {\n                             return;\n                           }\n\n                           /* publish existing property under new name, if it's not from us */\n                           Object.defineProperty(element, '_original_' + property, original_descriptor);\n                         }\n\n                         delete element[property];\n                         Object.defineProperty(element, property, descriptor);\n\n                         return true;\n                       }\n\n                       function is_field (element) {\n                               return element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement || element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLFieldSetElement || element === window.HTMLButtonElement.prototype || element === window.HTMLInputElement.prototype || element === window.HTMLSelectElement.prototype || element === window.HTMLTextAreaElement.prototype || element === window.HTMLFieldSetElement.prototype;\n                       }\n\n                       /**\n                        * set a custom validity message or delete it with an empty string\n                        */\n                       function setCustomValidity(element, msg) {\n                         if (!msg) {\n                           message_store.delete(element, true);\n                         } else {\n                           message_store.set(element, msg, true);\n                         }\n                         /* live-update the warning */\n                         var warning = Renderer.getWarning(element);\n                         if (warning) {\n                           Renderer.setMessage(warning, msg, element);\n                         }\n                         /* update any classes if the validity state changes */\n                         validity_state_checkers.valid(element);\n                       }\n\n                       /**\n                        * implement the valueAsDate functionality\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasdate\n                        */\n                       function valueAsDate(element) {\n                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         var type = get_type(element);\n                         if (dates.indexOf(type) > -1) {\n                           if (value !== undefined) {\n                             /* setter: value must be null or a Date() */\n                             if (value === null) {\n                               element.value = '';\n                             } else if (value instanceof Date) {\n                               if (isNaN(value.getTime())) {\n                                 element.value = '';\n                               } else {\n                                 element.value = date_to_string(value, type);\n                               }\n                             } else {\n                               throw new window.DOMException('valueAsDate setter encountered invalid value', 'TypeError');\n                             }\n                             return;\n                           }\n\n                           var value_date = string_to_date(element.value, type);\n                           return value_date instanceof Date ? value_date : null;\n                         } else if (value !== undefined) {\n                           /* trying to set a date on a not-date input fails */\n                           throw new window.DOMException('valueAsDate setter cannot set date on this element', 'InvalidStateError');\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * implement the valueAsNumber functionality\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasnumber\n                        */\n                       function valueAsNumber(element) {\n                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         var type = get_type(element);\n                         if (numbers.indexOf(type) > -1) {\n                           if (type === 'range' && element.hasAttribute('multiple')) {\n                             /* @see https://html.spec.whatwg.org/multipage/forms.html#do-not-apply */\n                             return NaN;\n                           }\n\n                           if (value !== undefined) {\n                             /* setter: value must be NaN or a finite number */\n                             if (isNaN(value)) {\n                               element.value = '';\n                             } else if (typeof value === 'number' && window.isFinite(value)) {\n                               try {\n                                 /* try setting as a date, but... */\n                                 valueAsDate(element, new Date(value));\n                               } catch (e) {\n                                 /* ... when valueAsDate is not responsible, ... */\n                                 if (!(e instanceof window.DOMException)) {\n                                   throw e;\n                                 }\n                                 /* ... set it via Number.toString(). */\n                                 element.value = value.toString();\n                               }\n                             } else {\n                               throw new window.DOMException('valueAsNumber setter encountered invalid value', 'TypeError');\n                             }\n                             return;\n                           }\n\n                           return string_to_number(element.value, type);\n                         } else if (value !== undefined) {\n                           /* trying to set a number on a not-number input fails */\n                           throw new window.DOMException('valueAsNumber setter cannot set number on this element', 'InvalidStateError');\n                         }\n\n                         return NaN;\n                       }\n\n                       /**\n                        *\n                        */\n                       function stepDown(element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         if (numbers.indexOf(get_type(element)) === -1) {\n                           throw new window.DOMException('stepDown encountered invalid type', 'InvalidStateError');\n                         }\n                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           throw new window.DOMException('stepDown encountered step \"any\"', 'InvalidStateError');\n                         }\n\n                         var prev = get_next_valid(element, n)[0];\n\n                         if (prev !== null) {\n                           valueAsNumber(element, prev);\n                         }\n                       }\n\n                       /**\n                        *\n                        */\n                       function stepUp(element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         if (numbers.indexOf(get_type(element)) === -1) {\n                           throw new window.DOMException('stepUp encountered invalid type', 'InvalidStateError');\n                         }\n                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           throw new window.DOMException('stepUp encountered step \"any\"', 'InvalidStateError');\n                         }\n\n                         var next = get_next_valid(element, n)[1];\n\n                         if (next !== null) {\n                           valueAsNumber(element, next);\n                         }\n                       }\n\n                       /**\n                        * get the validation message for an element, empty string, if the element\n                        * satisfies all constraints.\n                        */\n                       function validationMessage(element) {\n                         var msg = message_store.get(element);\n                         if (!msg) {\n                           return '';\n                         }\n\n                         /* make it a primitive again, since message_store returns String(). */\n                         return msg.toString();\n                       }\n\n                       /**\n                        * check, if an element will be subject to HTML5 validation at all\n                        */\n                       function willValidate(element) {\n                         return is_validation_candidate(element);\n                       }\n\n                       var gA = function gA(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, this.getAttribute(prop), this);\n                         };\n                       };\n\n                       var sA = function sA(prop) {\n                         return function (value) {\n                           this.setAttribute(prop, do_filter('attr_set_' + prop, value, this));\n                         };\n                       };\n\n                       var gAb = function gAb(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, this.hasAttribute(prop), this);\n                         };\n                       };\n\n                       var sAb = function sAb(prop) {\n                         return function (value) {\n                           if (do_filter('attr_set_' + prop, value, this)) {\n                             this.setAttribute(prop, prop);\n                           } else {\n                             this.removeAttribute(prop);\n                           }\n                         };\n                       };\n\n                       var gAn = function gAn(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, Math.max(0, Number(this.getAttribute(prop))), this);\n                         };\n                       };\n\n                       var sAn = function sAn(prop) {\n                         return function (value) {\n                           value = do_filter('attr_set_' + prop, value, this);\n                           if (/^[0-9]+$/.test(value)) {\n                             this.setAttribute(prop, value);\n                           }\n                         };\n                       };\n\n                       function install_properties(element) {\n                         var _arr = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step'];\n\n                         for (var _i = 0; _i < _arr.length; _i++) {\n                           var prop = _arr[_i];\n                           install_property(element, prop, {\n                             get: gA(prop),\n                             set: sA(prop)\n                           });\n                         }\n\n                         var _arr2 = ['multiple', 'required', 'readOnly'];\n                         for (var _i2 = 0; _i2 < _arr2.length; _i2++) {\n                           var _prop = _arr2[_i2];\n                           install_property(element, _prop, {\n                             get: gAb(_prop.toLowerCase()),\n                             set: sAb(_prop.toLowerCase())\n                           });\n                         }\n\n                         var _arr3 = ['minLength', 'maxLength'];\n                         for (var _i3 = 0; _i3 < _arr3.length; _i3++) {\n                           var _prop2 = _arr3[_i3];\n                           install_property(element, _prop2, {\n                             get: gAn(_prop2.toLowerCase()),\n                             set: sAn(_prop2.toLowerCase())\n                           });\n                         }\n                       }\n\n                       function uninstall_properties(element) {\n                         var _arr4 = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step', 'multiple', 'required', 'readOnly', 'minLength', 'maxLength'];\n\n                         for (var _i4 = 0; _i4 < _arr4.length; _i4++) {\n                           var prop = _arr4[_i4];\n                           uninstall_property(element, prop);\n                         }\n                       }\n\n                       var polyfills = {\n                         checkValidity: {\n                           value: mark(function () {\n                             return checkValidity(this);\n                           })\n                         },\n                         reportValidity: {\n                           value: mark(function () {\n                             return reportValidity(this);\n                           })\n                         },\n                         setCustomValidity: {\n                           value: mark(function (msg) {\n                             return setCustomValidity(this, msg);\n                           })\n                         },\n                         stepDown: {\n                           value: mark(function () {\n                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;\n                             return stepDown(this, n);\n                           })\n                         },\n                         stepUp: {\n                           value: mark(function () {\n                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;\n                             return stepUp(this, n);\n                           })\n                         },\n                         validationMessage: {\n                           get: mark(function () {\n                             return validationMessage(this);\n                           })\n                         },\n                         validity: {\n                           get: mark(function () {\n                             return ValidityState(this);\n                           })\n                         },\n                         valueAsDate: {\n                           get: mark(function () {\n                             return valueAsDate(this);\n                           }),\n                           set: mark(function (value) {\n                             valueAsDate(this, value);\n                           })\n                         },\n                         valueAsNumber: {\n                           get: mark(function () {\n                             return valueAsNumber(this);\n                           }),\n                           set: mark(function (value) {\n                             valueAsNumber(this, value);\n                           })\n                         },\n                         willValidate: {\n                           get: mark(function () {\n                             return willValidate(this);\n                           })\n                         }\n                       };\n\n                       function polyfill (element) {\n                         if (is_field(element)) {\n\n                           for (var prop in polyfills) {\n                             install_property(element, prop, polyfills[prop]);\n                           }\n\n                           install_properties(element);\n                         } else if (element instanceof window.HTMLFormElement || element === window.HTMLFormElement.prototype) {\n                           install_property(element, 'checkValidity', polyfills.checkValidity);\n                           install_property(element, 'reportValidity', polyfills.reportValidity);\n                         }\n                       }\n\n                       function polyunfill (element) {\n                         if (is_field(element)) {\n\n                           uninstall_property(element, 'checkValidity');\n                           uninstall_property(element, 'reportValidity');\n                           uninstall_property(element, 'setCustomValidity');\n                           uninstall_property(element, 'stepDown');\n                           uninstall_property(element, 'stepUp');\n                           uninstall_property(element, 'validationMessage');\n                           uninstall_property(element, 'validity');\n                           uninstall_property(element, 'valueAsDate');\n                           uninstall_property(element, 'valueAsNumber');\n                           uninstall_property(element, 'willValidate');\n\n                           uninstall_properties(element);\n                         } else if (element instanceof window.HTMLFormElement) {\n                           uninstall_property(element, 'checkValidity');\n                           uninstall_property(element, 'reportValidity');\n                         }\n                       }\n\n                       var instances = new WeakMap();\n\n                       /**\n                        * wrap <form>s, window or document, that get treated with the global\n                        * hyperform()\n                        */\n                       function Wrapper(form, settings) {\n\n                         /* do not allow more than one instance per form. Otherwise we'd end\n                          * up with double event handlers, polyfills re-applied, ... */\n                         var existing = instances.get(form);\n                         if (existing) {\n                           existing.settings = settings;\n                           return existing;\n                         }\n\n                         this.form = form;\n                         this.settings = settings;\n                         this.revalidator = this.revalidate.bind(this);\n\n                         instances.set(form, this);\n\n                         catch_submit(form, settings.revalidate === 'never');\n\n                         if (form === window || form.nodeType === 9) {\n                           /* install on the prototypes, when called for the whole document */\n                           this.install([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);\n                           polyfill(window.HTMLFormElement);\n                         } else if (form instanceof window.HTMLFormElement || form instanceof window.HTMLFieldSetElement) {\n                           this.install(form.elements);\n                           if (form instanceof window.HTMLFormElement) {\n                             polyfill(form);\n                           }\n                         }\n\n                         if (settings.revalidate === 'oninput' || settings.revalidate === 'hybrid') {\n                           /* in a perfect world we'd just bind to \"input\", but support here is\n                            * abysmal: http://caniuse.com/#feat=input-event */\n                           form.addEventListener('keyup', this.revalidator);\n                           form.addEventListener('change', this.revalidator);\n                         }\n                         if (settings.revalidate === 'onblur' || settings.revalidate === 'hybrid') {\n                           /* useCapture=true, because `blur` doesn't bubble. See\n                            * https://developer.mozilla.org/en-US/docs/Web/Events/blur#Event_delegation\n                            * for a discussion */\n                           form.addEventListener('blur', this.revalidator, true);\n                         }\n                       }\n\n                       Wrapper.prototype = {\n                         destroy: function destroy() {\n                           uncatch_submit(this.form);\n                           instances.delete(this.form);\n                           this.form.removeEventListener('keyup', this.revalidator);\n                           this.form.removeEventListener('change', this.revalidator);\n                           this.form.removeEventListener('blur', this.revalidator, true);\n                           if (this.form === window || this.form.nodeType === 9) {\n                             this.uninstall([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);\n                             polyunfill(window.HTMLFormElement);\n                           } else if (this.form instanceof window.HTMLFormElement || this.form instanceof window.HTMLFieldSetElement) {\n                             this.uninstall(this.form.elements);\n                             if (this.form instanceof window.HTMLFormElement) {\n                               polyunfill(this.form);\n                             }\n                           }\n                         },\n\n\n                         /**\n                          * revalidate an input element\n                          */\n                         revalidate: function revalidate(event) {\n                           if (event.target instanceof window.HTMLButtonElement || event.target instanceof window.HTMLTextAreaElement || event.target instanceof window.HTMLSelectElement || event.target instanceof window.HTMLInputElement) {\n\n                             if (this.settings.revalidate === 'hybrid') {\n                               /* \"hybrid\" somewhat simulates what browsers do. See for example\n                                * Firefox's :-moz-ui-invalid pseudo-class:\n                                * https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-ui-invalid */\n                               if (event.type === 'blur' && event.target.value !== event.target.defaultValue || ValidityState(event.target).valid) {\n                                 /* on blur, update the report when the value has changed from the\n                                  * default or when the element is valid (possibly removing a still\n                                  * standing invalidity report). */\n                                 reportValidity(event.target);\n                               } else if (event.type === 'keyup' && event.keyCode !== 9 || event.type === 'change') {\n                                 if (ValidityState(event.target).valid) {\n                                   // report instantly, when an element becomes valid,\n                                   // postpone report to blur event, when an element is invalid\n                                   reportValidity(event.target);\n                                 }\n                               }\n                             } else if (event.type !== 'keyup' || event.keyCode !== 9) {\n                               /* do _not_ validate, when the user \"tabbed\" into the field initially,\n                                * i.e., a keyup event with keyCode 9 */\n                               reportValidity(event.target);\n                             }\n                           }\n                         },\n\n\n                         /**\n                          * install the polyfills on each given element\n                          *\n                          * If you add elements dynamically, you have to call install() on them\n                          * yourself:\n                          *\n                          * js> var form = hyperform(document.forms[0]);\n                          * js> document.forms[0].appendChild(input);\n                          * js> form.install(input);\n                          *\n                          * You can skip this, if you called hyperform on window or document.\n                          */\n                         install: function install(els) {\n                           if (els instanceof window.Element) {\n                             els = [els];\n                           }\n\n                           var els_length = els.length;\n\n                           for (var i = 0; i < els_length; i++) {\n                             polyfill(els[i]);\n                           }\n                         },\n                         uninstall: function uninstall(els) {\n                           if (els instanceof window.Element) {\n                             els = [els];\n                           }\n\n                           var els_length = els.length;\n\n                           for (var i = 0; i < els_length; i++) {\n                             polyunfill(els[i]);\n                           }\n                         }\n                       };\n\n                       /**\n                        * try to get the appropriate wrapper for a specific element by looking up\n                        * its parent chain\n                        *\n                        * @return Wrapper | undefined\n                        */\n                       function get_wrapper(element) {\n                         var wrapped;\n\n                         if (element.form) {\n                           /* try a shortcut with the element's <form> */\n                           wrapped = instances.get(element.form);\n                         }\n\n                         /* walk up the parent nodes until document (including) */\n                         while (!wrapped && element) {\n                           wrapped = instances.get(element);\n                           element = element.parentNode;\n                         }\n\n                         if (!wrapped) {\n                           /* try the global instance, if exists. This may also be undefined. */\n                           wrapped = instances.get(window);\n                         }\n\n                         return wrapped;\n                       }\n\n                       /**\n                        * filter a form's elements for the ones needing validation prior to\n                        * a submit\n                        *\n                        * Returns an array of form elements.\n                        */\n                       function get_validated_elements(form) {\n                         var wrapped_form = get_wrapper(form);\n\n                         return Array.prototype.filter.call(form.elements, function (element) {\n                           /* it must have a name (or validating nameless inputs is allowed) */\n                           if (element.getAttribute('name') || wrapped_form && wrapped_form.settings.validateNameless) {\n                             return true;\n                           }\n                           return false;\n                         });\n                       }\n\n                       /**\n                        * return either the data of a hook call or the result of action, if the\n                        * former is undefined\n                        *\n                        * @return function a function wrapper around action\n                        */\n                       function return_hook_or (hook, action) {\n                         return function () {\n                           var data = call_hook(hook, Array.prototype.slice.call(arguments));\n\n                           if (data !== undefined) {\n                             return data;\n                           }\n\n                           return action.apply(this, arguments);\n                         };\n                       }\n\n                       /**\n                        * check an element's validity with respect to it's form\n                        */\n                       var checkValidity = return_hook_or('checkValidity', function (element) {\n                         /* if this is a <form>, check validity of all child inputs */\n                         if (element instanceof window.HTMLFormElement) {\n                           return get_validated_elements(element).map(checkValidity).every(function (b) {\n                             return b;\n                           });\n                         }\n\n                         /* default is true, also for elements that are no validation candidates */\n                         var valid = ValidityState(element).valid;\n                         if (valid) {\n                           var wrapped_form = get_wrapper(element);\n                           if (wrapped_form && wrapped_form.settings.validEvent) {\n                             trigger_event(element, 'valid');\n                           }\n                         } else {\n                           trigger_event(element, 'invalid', { cancelable: true });\n                         }\n\n                         return valid;\n                       });\n\n                       var version = '0.9.21';\n\n                       /* deprecate the old snake_case names\n                        * TODO: delme before next non-patch release\n                        */\n                       function w(name) {\n                         var deprecated_message = 'Please use camelCase method names! The name \"%s\" is deprecated and will be removed in the next non-patch release.';\n                         /* global console */\n                         console.log(sprintf(deprecated_message, name));\n                       }\n\n                       /**\n                        * public hyperform interface:\n                        */\n                       function hyperform(form) {\n                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n\n                         var classes = _ref.classes;\n                         var _ref$debug = _ref.debug;\n                         var debug = _ref$debug === undefined ? false : _ref$debug;\n                         var extend_fieldset = _ref.extend_fieldset;\n                         var extendFieldset = _ref.extendFieldset;\n                         var novalidate_on_elements = _ref.novalidate_on_elements;\n                         var novalidateOnElements = _ref.novalidateOnElements;\n                         var prevent_implicit_submit = _ref.prevent_implicit_submit;\n                         var preventImplicitSubmit = _ref.preventImplicitSubmit;\n                         var revalidate = _ref.revalidate;\n                         var _ref$strict = _ref.strict;\n                         var strict = _ref$strict === undefined ? false : _ref$strict;\n                         var valid_event = _ref.valid_event;\n                         var validEvent = _ref.validEvent;\n                         var _ref$validateNameless = _ref.validateNameless;\n                         var validateNameless = _ref$validateNameless === undefined ? false : _ref$validateNameless;\n\n\n                         if (!classes) {\n                           classes = {};\n                         }\n                         // TODO: clean up before next non-patch release\n                         if (extendFieldset === undefined) {\n                           if (extend_fieldset === undefined) {\n                             extendFieldset = !strict;\n                           } else {\n                             w('extend_fieldset');\n                             extendFieldset = extend_fieldset;\n                           }\n                         }\n                         if (novalidateOnElements === undefined) {\n                           if (novalidate_on_elements === undefined) {\n                             novalidateOnElements = !strict;\n                           } else {\n                             w('novalidate_on_elements');\n                             novalidateOnElements = novalidate_on_elements;\n                           }\n                         }\n                         if (preventImplicitSubmit === undefined) {\n                           if (prevent_implicit_submit === undefined) {\n                             preventImplicitSubmit = false;\n                           } else {\n                             w('prevent_implicit_submit');\n                             preventImplicitSubmit = prevent_implicit_submit;\n                           }\n                         }\n                         if (revalidate === undefined) {\n                           /* other recognized values: 'oninput', 'onblur', 'onsubmit' and 'never' */\n                           revalidate = strict ? 'onsubmit' : 'hybrid';\n                         }\n                         if (validEvent === undefined) {\n                           if (valid_event === undefined) {\n                             validEvent = !strict;\n                           } else {\n                             w('valid_event');\n                             validEvent = valid_event;\n                           }\n                         }\n\n                         var settings = { debug: debug, strict: strict, preventImplicitSubmit: preventImplicitSubmit, revalidate: revalidate,\n                           validEvent: validEvent, extendFieldset: extendFieldset, classes: classes, novalidateOnElements: novalidateOnElements,\n                           validateNameless: validateNameless\n                         };\n\n                         if (form instanceof window.NodeList || form instanceof window.HTMLCollection || form instanceof Array) {\n                           return Array.prototype.map.call(form, function (element) {\n                             return hyperform(element, settings);\n                           });\n                         }\n\n                         return new Wrapper(form, settings);\n                       }\n\n                       hyperform.version = version;\n\n                       hyperform.checkValidity = checkValidity;\n                       hyperform.reportValidity = reportValidity;\n                       hyperform.setCustomValidity = setCustomValidity;\n                       hyperform.stepDown = stepDown;\n                       hyperform.stepUp = stepUp;\n                       hyperform.validationMessage = validationMessage;\n                       hyperform.ValidityState = ValidityState;\n                       hyperform.valueAsDate = valueAsDate;\n                       hyperform.valueAsNumber = valueAsNumber;\n                       hyperform.willValidate = willValidate;\n\n                       hyperform.setLanguage = function (lang) {\n                         set_language(lang);return hyperform;\n                       };\n                       hyperform.addTranslation = function (lang, catalog) {\n                         add_translation(lang, catalog);return hyperform;\n                       };\n                       hyperform.setRenderer = function (renderer, action) {\n                         Renderer.set(renderer, action);return hyperform;\n                       };\n                       hyperform.addValidator = function (element, validator) {\n                         custom_validator_registry.set(element, validator);return hyperform;\n                       };\n                       hyperform.setMessage = function (element, validator, message) {\n                         custom_messages.set(element, validator, message);return hyperform;\n                       };\n                       hyperform.addHook = function (hook, action, position) {\n                         add_hook(hook, action, position);return hyperform;\n                       };\n                       hyperform.removeHook = function (hook, action) {\n                         remove_hook(hook, action);return hyperform;\n                       };\n\n                       // TODO: Remove in next non-patch version\n                       hyperform.set_language = function (lang) {\n                         w('set_language');set_language(lang);return hyperform;\n                       };\n                       hyperform.add_translation = function (lang, catalog) {\n                         w('add_translation');add_translation(lang, catalog);return hyperform;\n                       };\n                       hyperform.set_renderer = function (renderer, action) {\n                         w('set_renderer');Renderer.set(renderer, action);return hyperform;\n                       };\n                       hyperform.add_validator = function (element, validator) {\n                         w('add_validator');custom_validator_registry.set(element, validator);return hyperform;\n                       };\n                       hyperform.set_message = function (element, validator, message) {\n                         w('set_message');custom_messages.set(element, validator, message);return hyperform;\n                       };\n                       hyperform.add_hook = function (hook, action, position) {\n                         w('add_hook');add_hook(hook, action, position);return hyperform;\n                       };\n                       hyperform.remove_hook = function (hook, action) {\n                         w('remove_hook');remove_hook(hook, action);return hyperform;\n                       };\n\n                       if (document.currentScript && document.currentScript.hasAttribute('data-hf-autoload')) {\n                         hyperform(window);\n                       }\n\n                       return hyperform;\n\n}());"

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingButton__ = __webpack_require__(5);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-form');
  if (forms.length < 1) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Set button to loading
      var button = form.querySelector('.c-button');
      Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["c" /* setLoading */])(button);

      // Stop here if form isn't valid
      if (!form.checkValidity()) return;

      // Send the form
      sendForm(form).then(handleFetch).then(function (r) {
        if (r.error) {
          Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
          return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["a" /* setFinished */])(button);
        sendGTMEvent(form);
        setTimeout(function () {
          window.location = r.action;
          Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
          resetForm(form);
        }, 1000);
      }).catch(function (e) {
        console.error(e);
        Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
        window.alert('Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.');
      });
    });
  });

  /**
   * Send form
   */
  var sendForm = function sendForm(form) {
    return window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(form)
    });
  };

  /**
   * Reset form
   */
  var resetForm = function resetForm(form) {
    return form.reset();
  };

  /**
   * Handle fetch
   */
  var handleFetch = function handleFetch(r) {
    if (!r.ok) {
      var error = {
        error: 'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      };
      return error;
    } else {
      return r.json();
    }
  };

  var sendGTMEvent = function sendGTMEvent(form) {
    window.dataLayer = window.dataLayer || [];
    var data = {
      event: 'formSent',
      form: form.querySelector("input[name='form_id']") !== undefined && form.querySelector("input[name='form_id']") !== null ? form.querySelector("input[name='form_id']").value : 'Onbekend'
    };
    window.dataLayer.push(data);
  };
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Headers */
/* unused harmony export Request */
/* unused harmony export Response */
/* unused harmony export DOMException */
/* unused harmony export fetch */
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Depends On
 *
 * Hide/show form inputs based on
 * a radio/select input value
 * @since 1.0.0
 */

var DependsOn = function DependsOn() {
  var containers = document.querySelectorAll('.js-depends-on');
  if (containers.length < 1) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {

    var input_name = container.dataset.name;
    var input_value = container.dataset.value;
    var form = container.closest('.js-form');
    var leader_inputs = form.querySelectorAll('input[name="' + input_name + '"],select[name="' + input_name + '"]');
    var depender_inputs = container.querySelectorAll('input,textarea,select');
    var current_value = ''

    // disable all inputs inside c-depends-on
    ;[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
      input.disabled = true;
    });[].concat(_toConsumableArray(leader_inputs)).forEach(function (input) {

      if (input.checked) {
        // get checked radio button value
        current_value = input.value;
      }
      if (input.tagName === 'SELECT') {
        // get selected option value
        current_value = getCurrentOption(input);
      }

      // on first load
      if (current_value == input_value) {
        showDependers(container, depender_inputs);
      }

      // hide/show on click/change
      if (input.tagName !== 'SELECT') {
        // radio button
        input.addEventListener('click', function () {
          if (input.value == input_value) {
            showDependers(container, depender_inputs);
          } else {
            hideDependers(container, depender_inputs);
          }
        });
      } else {
        // select
        input.addEventListener('change', function () {
          current_value = getCurrentOption(input);
          if (current_value == input_value) {
            showDependers(container, depender_inputs);
          } else {
            hideDependers(container, depender_inputs);
          }
        });
      }
    }); // end foreach
  }); // end foreach
};

function getCurrentOption(input) {
  return input.options[input.selectedIndex].value;
}

function hideDependers(container, depender_inputs) {
  container.classList.remove('active');[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
    input.disabled = true;
  });
}

function showDependers(container, depender_inputs) {
  container.classList.add('active');[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
    input.disabled = false;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (DependsOn);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var UploadButton = function UploadButton() {
  var buttons = document.querySelectorAll('.js-upload-button');

  if (!buttons) return;[].concat(_toConsumableArray(buttons)).forEach(function (button) {
    var content = button.querySelector('.js-upload-content');
    var originalContent = content.innerHTML;
    var input = button.querySelector('.js-upload-input');
    var eraser = button.querySelector('.js-upload-eraser');

    button.addEventListener('change', function () {
      content.innerHTML = input.value.replace(/^.*\\/, '');

      if (input.files.length > 0 && input.files[0].size > 2000000) {
        window.alert('Het bestand is groter dan 2MB, probeer een kleiner bestand te versturen.');
        input.value = '';
        content.innerHTML = 'Selecteer een kleiner bestand.';
      }

      if (input.value !== '') {
        eraser.classList.add('active');
      }

      if (input.value === '') {
        content.innerHTML = originalContent;
        eraser.classList.remove('active');
      }
    });

    eraser.addEventListener('click', function () {
      input.value = '';
      content.innerHTML = originalContent;
      eraser.classList.remove('active');
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (UploadButton);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Images
 * 
 * NOTE: polyfill in /lib/Settings.php
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if (lazyImages.length < 1) return;

  // If the browser does NOT support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    lazyImages.forEach(function (lazyImage) {
      return updateSrc(lazyImage);
    });
    return;
  }

  var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var lazyImage = entry.target;
        updateSrc(lazyImage);
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  }, { rootMargin: '0px 0px 200px 0px' });
  // load 200px in advance

  lazyImages.forEach(function (lazyImage) {
    lazyImageObserver.observe(lazyImage);
  });
});

function updateSrc(lazyImage) {

  if (lazyImage.dataset.src) {
    lazyImage.src = lazyImage.dataset.src;
  }
  if (lazyImage.dataset.srcset) {
    lazyImage.srcset = lazyImage.dataset.srcset;
  }
  if (lazyImage.dataset.sizes) {
    lazyImage.sizes = lazyImage.dataset.sizes;
  }

  lazyImage.classList.add('loaded');
}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Picture
 * 
 * NOTE: polyfill in /lib/Settings.php
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyPictures = [].slice.call(document.querySelectorAll("picture.lazy"));
  if (lazyPictures.length < 1) return;

  // If the browser does NOT support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    lazyPictures.forEach(function (lazyPicture) {
      return updateSrc(lazyPicture);
    });
    return;
  }

  var lazyPictureObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var lazyPicture = entry.target;
        updateSrc(lazyPicture);
        lazyPictureObserver.unobserve(lazyPicture);
      }
    });
  }, { rootMargin: '0px 0px 200px 0px' });
  // load 200px in advance

  lazyPictures.forEach(function (lazyPicture) {
    lazyPictureObserver.observe(lazyPicture);
  });
});

function updateSrc(lazyPicture) {
  var elements = [].slice.call(lazyPicture.querySelectorAll("img,source"));

  elements.forEach(function (element) {
    if (element.dataset.src) {
      element.src = element.dataset.src;
    }
    if (element.dataset.srcset) {
      element.srcset = element.dataset.srcset;
    }
    if (element.dataset.sizes) {
      element.sizes = element.dataset.sizes;
    }
  });

  lazyPicture.classList.add('loaded');
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Video
 * 
 * NOTE: polyfill in /lib/Settings.php
 * 
 * We iterate through all of the child <source> elements 
 * and flip their data-src attributes to src attributes. 
 * Then we need to trigger loading of the video by calling the element's load method, 
 * after which the media will begin playing automatically per the autoplay attribute.
 * https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/#for_video_acting_as_an_animated_gif_replacement
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  if (lazyVideos.length < 1) return;

  // If the browser does NOT support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    lazyVideos.forEach(function (lazyVideo) {
      return updateSrc(lazyVideo);
    });
    return;
  }

  var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var video = entry.target;
        updateSrc(video);
        lazyVideoObserver.unobserve(video);
      }
    });
  }, { rootMargin: '0px 0px 200px 0px' });
  // load 200px in advance

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
});

function updateSrc(video) {

  for (var source in video.children) {
    var videoSource = video.children[source];
    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE" && videoSource.dataset.src) {
      videoSource.src = videoSource.dataset.src;
    }
  }

  video.load();
  video.classList.add("loaded");
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  /** Is there a map on the current page? */
  var mapElement = document.querySelector('.js-map');
  if (!mapElement) return;

  /**
   * Get coordinates from html data attributes.
   * Return early if values are missing.
   */
  var coordinates = getCoordinates(mapElement);
  if (!coordinates) {
    console.log('Missing coordinates. Fill all required fields in StoreMap pageblock.');
    return;
  }

  /**
   * Load the API and call the map.
   */
  var apiKey = 'AIzaSyD_TDxRL_8YCYreLnfbZHVYUNlbFDYo7bM'; //BRIGHT API KEY
  loadGoogleMapsAPI(apiKey);

  window.mapsCallback = function () {
    displayMap(coordinates.lat, coordinates.lng, coordinates.zoom);
  };

  /**
   * Build the map
   */
  function displayMap(lat, lng, zoom) {
    var styles = getSnazzyMapStyle();

    var coordinates = {
      lat: lat,
      lng: lng
    };

    var options = {
      zoom: zoom,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      scaleControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: styles

      // Show the map
    };var map = new window.google.maps.Map(document.getElementById('maps'), options);

    // Show the marker
    createMarker(map, lat, lng);
  }

  /**
   * Create a marker
   */
  function createMarker(map, lat, lng) {
    var icon = {
      url: '/wp-content/themes/demo/img/marker.svg',
      scaledSize: new window.google.maps.Size(100, 100) // scaled size
    };

    var marker = new window.google.maps.Marker({
      map: map,
      position: {
        lat: lat,
        lng: lng
      },
      icon: icon
    });

    return marker;
  }

  /**
   * Load google maps api
   */
  function loadGoogleMapsAPI(key) {
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=' + key + '&callback=mapsCallback';
    document.body.appendChild(script);
  }

  /**
   * Get coordinates: lng, lat, zoom
   */
  function getCoordinates(el) {
    if (!el.dataset.lat || !el.dataset.lng || !el.dataset.zoom) {
      return false;
    }

    var lat = parseFloat(el.dataset.lat);
    var lng = parseFloat(el.dataset.lng);
    var zoom = parseFloat(el.dataset.zoom);

    return {
      lat: lat,
      lng: lng,
      zoom: zoom
    };
  }

  /**
   * Google Maps styling
   * https://snazzymaps.com/style/253339/grayscale-simple
   */
  function getSnazzyMapStyle() {
    return [{
      featureType: 'administrative',
      elementType: 'all',
      stylers: [{
        visibility: 'on'
      }, {
        lightness: 33
      }]
    }, {
      featureType: 'administrative',
      elementType: 'labels',
      stylers: [{
        saturation: '-100'
      }]
    }, {
      featureType: 'administrative',
      elementType: 'labels.text',
      stylers: [{
        gamma: '0.75'
      }]
    }, {
      featureType: 'administrative.neighborhood',
      elementType: 'labels.text.fill',
      stylers: [{
        lightness: '-37'
      }]
    }, {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{
        color: '#f9f9f9'
      }]
    }, {
      featureType: 'landscape.man_made',
      elementType: 'geometry',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '40'
      }, {
        visibility: 'off'
      }]
    }, {
      featureType: 'landscape.natural',
      elementType: 'labels.text.fill',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '-37'
      }]
    }, {
      featureType: 'landscape.natural',
      elementType: 'labels.text.stroke',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '100'
      }, {
        weight: '2'
      }]
    }, {
      featureType: 'landscape.natural',
      elementType: 'labels.icon',
      stylers: [{
        saturation: '-100'
      }]
    }, {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '80'
      }]
    }, {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '0'
      }]
    }, {
      featureType: 'poi.attraction',
      elementType: 'geometry',
      stylers: [{
        lightness: '-4'
      }, {
        saturation: '-100'
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{
        color: '#c5dac6'
      }, {
        visibility: 'on'
      }, {
        saturation: '-95'
      }, {
        lightness: '62'
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'labels',
      stylers: [{
        visibility: 'on'
      }, {
        lightness: 20
      }]
    }, {
      featureType: 'road',
      elementType: 'all',
      stylers: [{
        lightness: 20
      }]
    }, {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{
        saturation: '-100'
      }, {
        gamma: '1.00'
      }]
    }, {
      featureType: 'road',
      elementType: 'labels.text',
      stylers: [{
        gamma: '0.50'
      }]
    }, {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [{
        saturation: '-100'
      }, {
        gamma: '0.50'
      }, {
        visibility: 'off'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{
        color: '#c5c6c6'
      }, {
        saturation: '-100'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{
        lightness: '-13'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'labels.icon',
      stylers: [{
        lightness: '0'
      }, {
        gamma: '1.09'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [{
        color: '#e4d7c6'
      }, {
        saturation: '-100'
      }, {
        lightness: '47'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [{
        lightness: '-12'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [{
        saturation: '-100'
      }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [{
        color: '#fbfaf7'
      }, {
        lightness: '77'
      }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [{
        lightness: '-5'
      }, {
        saturation: '-100'
      }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [{
        saturation: '-100'
      }, {
        lightness: '-15'
      }]
    }, {
      featureType: 'transit.station.airport',
      elementType: 'geometry',
      stylers: [{
        lightness: '47'
      }, {
        saturation: '-100'
      }]
    }, {
      featureType: 'water',
      elementType: 'all',
      stylers: [{
        visibility: 'on'
      }, {
        color: '#acbcc9'
      }]
    }, {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{
        saturation: '53'
      }]
    }, {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{
        lightness: '-42'
      }, {
        saturation: '17'
      }]
    }, {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{
        lightness: '61'
      }]
    }];
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-read-more');

  if (containers.length > 0) {
    ;[].concat(_toConsumableArray(containers)).forEach(function (container) {
      var link = container.querySelector('.js-read-more__link');
      var state = container.dataset.visible === 'true';
      var onClick = function onClick() {
        state = !state;
        container.dataset.visible = state;
      };

      link.onclick = onClick;
    });
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var headers = document.querySelectorAll('.js-sticky-header');
  var scrollPos = 0;
  var scrolledUp = false;

  if (headers.length < 1) return;

  window.addEventListener('scroll', handleScroll);

  function handleScroll() {
    scrolledUp = document.body.getBoundingClientRect().top > scrollPos

    // loop through all headers
    ;[].concat(_toConsumableArray(headers)).forEach(function (header) {
      // we're NOT at the top of the page
      if (window.pageYOffset > 300) {
        document.body.classList.add('scrolled-down');
        // we're scrolling up
        if (scrolledUp) {
          if (!header.classList.contains('active')) {
            header.classList.add('active');
          }
          // we're scrolling down
        } else {
          if (header.classList.contains('active')) {
            header.classList.remove('active');
          }
        }

        // we're at the top of the page
      } else {
        if (header.classList.contains('active')) {
          header.classList.remove('active');
        }

        if (document.body.classList.contains('scrolled-down')) {
          document.body.classList.remove('scrolled-down');
        }
      }
    });

    // saves the new position for iteration.
    scrollPos = document.body.getBoundingClientRect().top;
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var triggers = document.querySelectorAll('.js-click');
  if (triggers.length < 1) return;
  console.log('xd');[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      trigger.classList.toggle('active');
    });
  });
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var cover = document.querySelector('.js-mobile-cover');
  var triggers = document.querySelectorAll('.js-toggle-mobile-cover');[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      cover.classList.toggle('active');
      document.body.classList.toggle('menu-open');

      if (cover.classList.contains('active')) {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(cover);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(cover);
      }
    });
  });
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadingButton__ = __webpack_require__(5);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-login-form');
  if (forms.length < 1) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Set button to loading
      var button = form.querySelector('.c-button');
      Object(__WEBPACK_IMPORTED_MODULE_0__LoadingButton__["c" /* setLoading */])(button);

      // Stop here if form isn't valid
      if (!form.checkValidity()) return;

      setTimeout(function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__LoadingButton__["a" /* setFinished */])(button);
        form.submit();
      }, 1000);
    });
  });
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-swipe-slider-parent');

  if (sliderParents.length < 1) return;
  if (document.body.clientWidth < 1000) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {

    // Variables
    var slider = sliderParent.querySelector('.js-swipe-slider');
    // const slides = sliderParent.querySelectorAll('.js-swipe-slide')
    var firstSlide = sliderParent.querySelector('.js-swipe-slide');
    var next = sliderParent.querySelector('.js-swipe-slider-next');
    var prev = sliderParent.querySelector('.js-swipe-slider-prev');

    var slidesCount = sliderParent.querySelectorAll('.js-swipe-slide').length;
    var slideWidth = firstSlide.offsetWidth;
    var sliderWidth = slider.offsetWidth;
    var sliderScrollWidth = slider.scrollWidth;

    var pos = 0;
    var shown = sliderWidth;

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      sliderWidth = slider.offsetWidth;
      sliderScrollWidth = slider.scrollWidth;
      pos = 0;
      shown = sliderWidth;
      setTransform();
      navActivity();
    });

    // Events
    prev.addEventListener('click', function () {
      goPrev();
      navActivity();
      // currentSlide()
    });

    next.addEventListener('click', function () {
      goNext();
      navActivity();
      // currentSlide()
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 39) {
        goNext();
        navActivity();
      }
      if (e.keyCode === 37) {
        goPrev();
        navActivity();
      }
    });

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0);
        setTransform();
        shown = shown - slideWidth;
      }
    }

    function goNext() {
      if (shown < sliderScrollWidth) {
        pos = Math.min(pos + 1, slidesCount - 1);
        setTransform();
        shown = shown + slideWidth;
      }
    }

    function navActivity() {

      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive');
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive');
        }
      }

      if (shown < sliderScrollWidth) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive');
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive');
        }
      }
    }

    /**
     * Add .current to the currently visible slider on the far left
     * NOTE: remember to add .current to the first slide in twig file
     */
    // function currentSlide() {
    //   ;[...slides].forEach( (slide, index) => {
    //     if (index === pos) {
    //       if (! slide.classList.contains('current')) {
    //         slide.classList.add('current')
    //       }
    //     } else {
    //       if (slide.classList.contains('current')) {
    //         slide.classList.remove('current')
    //       }
    //     }
    //   })
    // }
  }); // end foreach
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-swipe-one-slider-parent');

  if (sliderParents.length < 1) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    // Variables
    var slider = sliderParent.querySelector('.js-swipe-one-slider');
    var firstSlide = sliderParent.querySelector('.js-swipe-one-slide');
    var slides = sliderParent.querySelectorAll('.js-swipe-one-slide');
    var next = sliderParent.querySelector('.js-swipe-one-slider-next');
    var prev = sliderParent.querySelector('.js-swipe-one-slider-prev');
    var dots = sliderParent.querySelectorAll('.js-swipe-one-slider-dot');

    var slidesCount = sliderParent.querySelectorAll('.js-swipe-one-slide').length;
    var slideWidth = firstSlide.offsetWidth;

    var pos = 0;[].concat(_toConsumableArray(slides)).forEach(function (slide, index) {
      if (slide.dataset.active === 'true') {
        pos = index;
        setTransform();
        navActivity();
        dotActivity();
      }
    });

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      pos = 0;
      setTransform();
      navActivity();
      dotActivity();[].concat(_toConsumableArray(slides)).forEach(function (slide, index) {
        if (slide.dataset.active === 'true') {
          pos = index;
          setTransform();
          navActivity();
          dotActivity();
        }
      });
    });

    // Events
    prev.addEventListener('click', function () {
      goPrev();
      navActivity();
      dotActivity();
    });

    next.addEventListener('click', function () {
      console.log(prev);
      goNext();
      navActivity();
      dotActivity();
    });[].concat(_toConsumableArray(dots)).forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
        navActivity();
        dotActivity();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 39) {
        goNext();
        navActivity();
        dotActivity();
      }
      if (e.keyCode === 37) {
        goPrev();
        navActivity();
        dotActivity();
      }
    });

    // Helper functions
    function setTransform() {
      if (slider.classList.contains('js-hero-slider')) {
        slider.style['transform'] = 'translate3d(' + (-pos * slideWidth + -pos * 25) + 'px,0,0)';
      } else {
        slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
      }
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0);
        setTransform();
      }
    }

    function goNext() {
      if (pos < slidesCount) {
        pos = Math.min(pos + 1, slidesCount - 1);
        setTransform();
      }
    }

    function goTo(index) {
      pos = Math.max(index);
      setTransform();
    }

    function navActivity() {
      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive');
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive');
        }
      }

      if (pos + 1 < slidesCount) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive');
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive');
        }
      }
    }

    function dotActivity() {
      ;[].concat(_toConsumableArray(dots)).forEach(function (dot, index) {
        if (index === pos) {
          if (!dot.classList.contains('active')) {
            dot.classList.add('active');
          }
        } else {
          if (dot.classList.contains('active')) {
            dot.classList.remove('active');
          }
        }
      });
    }
  }); // end foreach
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var Lightbox = function Lightbox() {
  var images = document.querySelectorAll('.js-lightbox-image');
  if (images.length < 1) return;[].concat(_toConsumableArray(images)).forEach(function (image, index) {
    image.addEventListener('click', addLightbox.bind(null, image));
  });
};

function addLightbox(element, e) {
  e.preventDefault();
  var currentElement = element;
  var prevImg = currentElement.previousElementSibling;
  var parentElement = currentElement.parentElement;

  if (prevImg) {
    prevImg = prevImg.closest('.js-lightbox-image') ? prevImg : prevImg.previousElementSibling;
  }

  var nextImg = currentElement.nextElementSibling;
  if (nextImg) {
    nextImg = nextImg.closest('.js-lightbox-image') ? nextImg : nextImg.nextElementSibling;
  }

  if (parentElement.classList.contains('js-thumbnail-slide')) {
    var nextParent = parentElement.nextElementSibling;
    var prevParent = parentElement.previousElementSibling;

    if (nextParent) {
      var nextEl = nextParent.querySelector('.js-lightbox-image');
      nextImg = nextEl;
    }

    if (prevParent) {
      var prevEl = prevParent.querySelector('.js-lightbox-image');
      prevImg = prevEl;
    }
  }

  // get img src
  var url = element.closest('.js-lightbox-image');
  var src = url.getAttribute('href');

  // create lightbox elements
  var lightbox = document.createElement('div');
  var loader = document.createElement('div');
  var image = document.createElement('img');
  var cross = document.createElement('div');
  var next = document.createElement('div');
  var prev = document.createElement('div');

  // set elements
  lightbox.setAttribute('id', 'js-lightbox');
  lightbox.setAttribute('class', 'c-lightbox');
  loader.setAttribute('class', 'c-lightbox__loader');
  image.setAttribute('class', 'c-lightbox__image');
  image.setAttribute('src', src);
  cross.setAttribute('class', 'c-lightbox__cross');
  next.setAttribute('class', 'c-lightbox__next');
  prev.setAttribute('class', 'c-lightbox__prev');

  // add to dom
  document.body.appendChild(lightbox);
  lightbox.appendChild(loader);
  lightbox.appendChild(image);
  lightbox.appendChild(cross);

  if (nextImg) {
    lightbox.appendChild(next);
    next.addEventListener('click', function (e) {
      e.preventDefault();
      var nextUrl = nextImg.closest('.js-lightbox-image');
      var nextSrc = nextUrl.getAttribute('href');
      currentElement = nextImg;
      document.body.removeChild(lightbox);
      addLightbox(nextImg, e);
      image.setAttribute('src', nextSrc);
    });
  }

  if (prevImg) {
    lightbox.appendChild(prev);
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      var prevUrl = prevImg.closest('.js-lightbox-image');
      var prevSrc = prevUrl.getAttribute('href');
      currentElement = prevImg;
      document.body.removeChild(lightbox);
      addLightbox(prevImg, e);
      image.setAttribute('src', prevSrc);
    });
  }

  // on image load
  image.addEventListener('load', function () {
    image.classList.add('c-lightbox__image--loaded');
    loader.classList.add('c-lightbox__loader--loaded');
  });

  Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(currentElement);

  // remove if clicked again
  cross.addEventListener('click', function (e) {
    if (e.target !== next && e.target !== prev) {
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(currentElement);
      document.body.removeChild(lightbox);
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Lightbox);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var elements = document.querySelectorAll('.js-parent-click');
  if (elements.length < 1) return;[].concat(_toConsumableArray(elements)).forEach(function (element) {
    var trigger = element.querySelector('.js-child-click');

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        element.classList.toggle('active');

        if (trigger.classList.contains('c-images__button-container')) {
          trigger.remove();
        }
      });
    }
  });
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-video-container');
  if (containers.length < 1) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var video = container.querySelector('.js-video');
    var playButton = container.querySelector('.js-video-play');
    var overlay = container.querySelector('.js-video-overlay');
    var image = container.querySelector('.js-video-image');
    var youtube = container.querySelector('.js-youtube-video');

    // Video has buffered enough to play
    if (video) {
      video.addEventListener('canplay', function () {
        if (video.autoplay && !youtube) {
          // Fade out the image if video is autoplay
          image.classList.add('hidden');
        }
      });
    }

    // Play video
    if (playButton) {
      playButton.addEventListener('click', function () {
        if (image !== null) {
          image.classList.add('hidden');
        }

        overlay.classList.add('hidden');
        playButton.classList.add('hidden');

        if (youtube) {
          video.classList.add('active');
        }

        if (video) {
          video.classList.add('active');
          if (video.readyState > 0) {
            //ie11 fix
            video.currentTime = 0;
          }
          video.controls = true;
          video.muted = false;
          video.play();

          // Turn on any subtitles
          for (var i = 0; i < video.textTracks.length; i++) {
            video.textTracks[i].mode = 'showing';
          }
        }
      });
    }
  });
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-video-popup');
  if (containers.length < 1) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var thumbnails = document.querySelectorAll('.c-featured-videos__video-row');
    var closeButton = container.querySelector('.js-close-button');
    var video = container.querySelector('.js-video');
    var playButton = container.querySelector('.js-video-play');
    var overlay = container.querySelector('.js-video-overlay');

    var source = document.createElement('source');

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(container);
        container.classList.toggle('c-featured-videos__video-container--active');
        source.remove();
        video.pause();
        playButton.classList.remove('hidden');
        overlay.classList.remove('hidden');
      });
    }

    ;[].concat(_toConsumableArray(thumbnails)).forEach(function (thumbnail, index) {
      thumbnail.querySelector('.c-button').addEventListener('click', function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(container);
        event.preventDefault();
        container.classList.toggle('c-featured-videos__video-container--active');
        source.setAttribute('src', thumbnail.getAttribute('url'));
        video.appendChild(source);
        video.load();
      });
    });
  });
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-product-slider-parent');

  if (sliderParents.length < 1) return;
  if (document.body.clientWidth < 1000) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    // Variables
    var slider = sliderParent.querySelector('.js-product-slider');
    // const slides = sliderParent.querySelectorAll('.js-product-slide')
    var firstSlide = sliderParent.querySelector('.js-product-slide');
    var next = sliderParent.querySelector('.js-product-slider-next');
    var prev = sliderParent.querySelector('.js-product-slider-prev');

    var slidesCount = sliderParent.querySelectorAll('.js-product-slide').length;
    var slideWidth = firstSlide.offsetWidth;
    var sliderWidth = slider.offsetWidth;
    var sliderScrollWidth = slider.scrollWidth;

    var pos = 0;
    var shown = sliderWidth;

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      sliderWidth = slider.offsetWidth;
      sliderScrollWidth = slider.scrollWidth;
      pos = 0;
      shown = sliderWidth;
      setTransform();
      navActivity();
    });

    // Events
    prev.addEventListener('click', function () {
      goPrev();
      navActivity();
      // currentSlide()
    });

    next.addEventListener('click', function () {
      goNext();
      navActivity();
      // currentSlide()
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 39) {
        goNext();
        navActivity();
      }
      if (e.keyCode === 37) {
        goPrev();
        navActivity();
      }
    });

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0);
        setTransform();
        shown = shown - slideWidth;
      }
    }

    function goNext() {
      if (shown < sliderScrollWidth) {
        pos = Math.min(pos + 1, slidesCount - 1);
        setTransform();
        shown = shown + slideWidth;
      }
    }

    function navActivity() {
      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive');
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive');
        }
      }

      if (shown < sliderScrollWidth) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive');
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive');
        }
      }
    }

    /**
     * Add .current to the currently visible slider on the far left
     * NOTE: remember to add .current to the first slide in twig file
     */
    // function currentSlide() {
    //   ;[...slides].forEach( (slide, index) => {
    //     if (index === pos) {
    //       if (! slide.classList.contains('current')) {
    //         slide.classList.add('current')
    //       }
    //     } else {
    //       if (slide.classList.contains('current')) {
    //         slide.classList.remove('current')
    //       }
    //     }
    //   })
    // }
  }); // end foreach
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var wishlists = document.querySelectorAll('.js-wishlist');
  if (wishlists.length < 1) return;[].concat(_toConsumableArray(wishlists)).forEach(function (wishlist) {
    wishlist.addEventListener('click', function (e) {
      wishlist.classList.add('loading');
      wishlist.classList.remove('active');

      window.fetch('/wordpress/wp-admin/admin-ajax.php?action=' + wishlist.dataset.action + '_favorites', {
        credentials: 'same-origin',
        method: 'post',
        body: JSON.stringify({
          id: wishlist.dataset.id,
          type: wishlist.dataset.type
        })
      }).then(function (response) {
        return response.json();
      }).then(function (r) {
        console.log(r);
        wishlist.classList.remove('loading');
        wishlist.classList.add('success');
        window.setTimeout(function () {
          wishlist.classList.remove('success');
          if (wishlist.dataset.action === 'add') {
            wishlist.classList.add('active');
            wishlist.dataset.action = 'remove';
          } else {
            wishlist.dataset.action = 'add';
          }
        }, 1000);
      });
    });
  });
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var elements = document.querySelectorAll('.parallax');
  if (elements.length < 1) return;[].concat(_toConsumableArray(elements)).forEach(function (element) {
    console.log(element);
  });
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-thumbnail-slider-parent');

  if (sliderParents.length < 1) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    // Variables
    var slider = sliderParent.querySelector('.js-thumbnail-slider');
    // const slides = sliderParent.querySelectorAll('.js-thumbnail-slide')
    var firstSlide = sliderParent.querySelector('.js-thumbnail-slide');
    var next = sliderParent.querySelector('.js-thumbnail-slider-next');
    var prev = sliderParent.querySelector('.js-thumbnail-slider-prev');
    var thumbnails = sliderParent.querySelectorAll('.js-thumbnail-slider-thumbnail');
    var slidesCount = sliderParent.querySelectorAll('.js-thumbnail-slide').length;
    var slideWidth = firstSlide.offsetWidth;
    var sliderWidth = slider.offsetWidth;
    var sliderScrollWidth = slider.scrollWidth;

    var pos = 0;
    var shown = sliderWidth;

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      sliderWidth = slider.offsetWidth;
      sliderScrollWidth = slider.scrollWidth;
      pos = 0;
      shown = sliderWidth;
      setTransform();
      navActivity();
    });

    // Events
    prev.addEventListener('click', function () {
      goPrev();
      navActivity();
      // currentSlide()
    });

    next.addEventListener('click', function () {
      goNext();
      navActivity();
      // currentSlide()
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 39) {
        goNext();
        navActivity();
      }
      if (e.keyCode === 37) {
        goPrev();
        navActivity();
      }
    });[].concat(_toConsumableArray(thumbnails)).forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (e) {
        var currentPos = pos;
        var targetPos = Number(e.currentTarget.dataset.pos);
        pos = targetPos;
        setTransform();
        if (currentPos > targetPos) {
          shown = shown - slideWidth * (currentPos - targetPos);
        } else {
          shown = shown + slideWidth * (targetPos - currentPos);
        }
        navActivity();
      });
    });

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0);
        setTransform();
        shown = shown - slideWidth;
      }
    }

    function goNext() {
      if (shown < sliderScrollWidth) {
        pos = Math.min(pos + 1, slidesCount - 1);
        setTransform();
        shown = shown + slideWidth;
      }
    }

    function navActivity() {
      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive');
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive');
        }
      }

      if (shown < sliderScrollWidth) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive');
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive');
        }
      }
    }

    /**
     * Add .current to the currently visible slider on the far left
     * NOTE: remember to add .current to the first slide in twig file
     */
    // function currentSlide() {
    //   ;[...slides].forEach( (slide, index) => {
    //     if (index === pos) {
    //       if (! slide.classList.contains('current')) {
    //         slide.classList.add('current')
    //       }
    //     } else {
    //       if (slide.classList.contains('current')) {
    //         slide.classList.remove('current')
    //       }
    //     }
    //   })
    // }
  }); // end foreach
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Tabs
 * @since 1.0.0
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-tabs');
  if (containers.length < 1) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var triggers = container.querySelectorAll('.js-tabs-trigger');
    var panels = container.querySelectorAll('.js-tabs-panel');

    if (triggers.length < 1 || panels.length < 1 || triggers.length !== panels.length) {
      throw Error('Tabs.js: missing one or more triggers and/or panels');
    }

    ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
      trigger.addEventListener('click', addActive);
    });

    /**
     * Toggle .active classes if click a trigger
     */
    function addActive(e) {
      var clickedTrigger = e.currentTarget;
      var name = clickedTrigger.dataset.name;
      var matchingPanel = container.querySelector('.js-tabs-panel[data-name=' + name + ']');

      if (!clickedTrigger.classList.contains('active')) {
        closeAll();
        clickedTrigger.classList.add('active');
        matchingPanel.classList.add('active');
      }
    }

    /**
     * Remove all .active classes
     */
    function closeAll() {
      ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
        if (trigger.classList.contains('active')) {
          trigger.classList.remove('active');
        }
      });[].concat(_toConsumableArray(panels)).forEach(function (panel) {
        if (panel.classList.contains('active')) {
          panel.classList.remove('active');
        }
      });
    }
  });
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var triggers = document.querySelectorAll('.js-blur');[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('blur', function (e) {
      trigger.classList.add('active');
    });
  });
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-car-video');

  if (!container) return;

  var video = container.querySelector('.js-car-video-video');

  if (!video) return;

  // 2. This code loads the IFrame Player API code asynchronously.
  var tag = document.createElement('script');

  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  console.log(tag);
  var youtube = container.querySelector('.js-car-video-youtube');
  var playbutton = container.querySelector('.js-car-video-button');

  var player = {};
  window.onYouTubeIframeAPIReady = function () {
    console.log('YouTube ready!');
    player = new YT.Player('car-video', {
      height: 'auto',
      width: '100%',
      videoId: youtube.dataset.key,
      playerVars: {
        playsinline: 1
      }
    });
  };

  playbutton.addEventListener('click', function (e) {
    playbutton.remove();
    video.remove();
    player.playVideo();
  });
});

/***/ })
],[138]);


// WEBPACK FOOTER //
// main.3a5e4e556300380a57d1.js